<template>
  <div>
    {{ showClosePopUp }}{{ showCloseEditPopUp }}{{ getInvestigationId }}
    <div v-if="show_modal" style="position: absolute; z-index: 200">
      <transition name="modal">
        <div class="modalhold annotation-modal">
          <div class="modal-mask upl-hold" style="overflow-y: auto; display: block">
            <div class="modal-wrapper">
              <div class="modal-container wider-midB clinicalnote genamet-platform">
                <div class="section-loader prescription-popup" v-if="showloader">
                  <img src="../../static/images/loader-icon.png" id="loading" />
                </div>
                <!--Modal header-->
                <div class="modal-headers pb-0 border-bottom-0 pt-0">
                  <div class="ehr-popup-header-colored popup-header-blue">
                    <div class="ehr-popup-title">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round" style="width:18px;height:18px;">
                        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                        <polyline points="2 17 12 22 22 17"></polyline>
                        <polyline points="2 12 12 17 22 12"></polyline>
                      </svg>
                      {{ uploadfrom == 'genamet' ? 'Insert from Genamet Platform' :'Upload Picture — This Device' }}
                    </div>
                    <button type="button" @click.prevent="closePopUp('goBack')" aria-label="Close"
                      class="ehr-popup-close">×</button>
                  </div>
                  <!-- <slot name="header" style="border: 1px red">
                    <h5 class="modal-title mb-0">Examination Findings</h5>
                    <button type="button" aria-label="Close" class="close up-close"
                      @click.prevent="closePopUp('goBack')">
                      ×
                    </button>
                  </slot> -->
                </div>
                <!--Modal Body-->
                <div class="col-md-12 model-body-popup">
                  <div class="layout_2">
                    <slot name="body">
                      <div class="upload-outer">
                        <div class="" :class="show_add_diatgnosticCenter ? 'mart-50' : ' '">
                          <!-- <div v-if="hidesection && uploadfrom=='genamet'" class="col-md-12">
                            <multiselect
                              class="select"
                              v-model="selectedimageCategory"
                              :multiple="false"
                              :options="categorylist"
                              label="category"
                              track-by="category"
                              placeholder="Select category"
                            ></multiselect>
                          </div> -->
                          <div v-if="hidesection && uploadfrom == 'local'" class="mt-3">
                            <div class="popup-section-label">Step 1 · Select the file</div>
                            <div class="pup-drop" :class="{ 'is-dragover': dragOver }" @click="pupChoose"
                              @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false"
                              @drop.prevent="pupDropFile">
                              <span class="pup-drop-ico">
                                <svg viewBox="0 0 24 24">
                                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                                  <polyline points="21 15 16 10 5 21"></polyline>
                                </svg>
                              </span>
                              <span class="pup-drop-txt">
                                <span class="pup-drop-title">{{ fileName || 'Choose a picture from this device'
                                }}</span>
                                <span class="pup-drop-hint">JPG, PNG or HEIC — or drag the file into this area</span>
                              </span>
                              <button class="pup-drop-cta" type="button" @click.stop="pupChoose">Upload File</button>
                            </div>

                            <!-- native input stays (id used by your existing code) but is hidden -->
                            <input type="file" ref="fileInput" id="fileUpload" class="d-none" accept="image/*"
                              @change="onFileChosen" @error="imageLoadError" @click="resetValidation">

                            <span v-if="!validFileExt" class="d-block"><span class="info-upload-mail">Invalid file
                                type</span></span>
                            <span v-if="!validFileSize" class="d-block"><span class="info-upload-mail">Selected file
                                size is invalid</span></span>
                          </div>

                          <div v-if="hidesection && uploadfrom == 'genamet'" class="col-md-12">
                            <ul class="annotation-cat">
                              <li><a href="#" @click.prevent="setall"
                                  :class="['categorysel', 'selectAll', { active: selectedimageCategory && selectedimageCategory.category === 'All' }]">All</a>
                              </li>
                              <li v-for="item in categorylist" :key="item.category">
                                <a href="#" @click.prevent="setcategory(item.category)"
                                  :class="['categorysel', 'select' + item.category, { active: selectedimageCategory && selectedimageCategory.category === item.category }]">{{ item.category }}</a>
                              </li>
                            </ul>
                          </div>
                          <div v-if="hidesection && uploadfrom == 'genamet'" class="col-md-12">
                            <div class="annotation-gallery">
                              <h4 v-if="selectedimageCategory != null">{{ selectedimageCategory.category }}</h4>
                              <div class="row">
                                <div v-for="item in allimages" class="col-md-4">
                                  <div class="annotation-image thumbnail">
                                    <img :src="item.url" :alt="item.name" />
                                    <span id="tick">
                                      <input type="radio" v-model="imgUrl" :value="item.url">
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="loader">
                            <div class="processing_popup upload full-spinner" style="visibility: visible">
                              <div class="spinner">
                                <div class="bounce1"></div>
                                <div class="bounce2"></div>
                                <div class="bounce3"></div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div id="popupContainer" style="display: none">
                              <!-- Content of the popup goes here -->
                            </div>
                            <div class="row marker-container" id="editor" style="
                                display: none;
                                margin-bottom: 25px;
                                border-bottom: 1px solid #808080;
                              ">
                              <div class="col-md-12" id="sidebarMenu">
                                <nav class="">
                                  <div class="sidebar-sticky pt-3">
                                    <ul class="nav flex-column">
                                      <li class="nav-item">
                                        <a class="nav-link active" href="#" id="btnAnnotate"
                                          @click="showMarkerArea(this)">
                                          <img src="@/static/images/annotate-icon.png" alt="">
                                          Annotate
                                          <span class="sr-only">(current)</span>
                                        </a>
                                      </li>
                                      <li class="nav-item">
                                        <a class="nav-link" href="#" id="btnRotate" @click="showCropArea(this)">
                                          <img src="@/static/images/rotate-icon.png" alt="">
                                          Rotate
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </nav>
                              </div>

                              <div class="col-md-12">
                                <div class="holder">
                                  <img id="imgPreview" src="#" alt="pic" />
                                </div>
                                <!-- <div class="form-group">
                                  <input
                                    type="button"
                                    class="btn btn-primary"
                                    value="Submit"
                                    id="btnSubmit"
                                    @click="onsubmitann"
                                    style="display: none"
                                  />
                                </div> -->
                              </div>
                            </div>
                            <!-- <div class="row">
                              <div v-for="item in allimages" class="col-md-4">
                                <div class="thumbnail">
                                  <img :src="item.url" :alt="item.name" />
                                  <div class="caption">
                                    <h3>{{ item.name }}</h3>
                                    <p>{{ item.category }}</p>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                        <!-- row -->
                      </div>
                    </slot>
                  </div>
                  <div class="mt-4">
                    <div class="popup-section-label">Step 2 · Clinical context for this picture</div>
                    <div class="pup-grid">
                      <div class="pup-field">
                        <div class="pup-field-label">
                          <svg viewBox="0 0 24 24">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          <label for="featuresNoted">Signs / Features Noted</label>
                        </div>
                        <textarea id="featuresNoted" v-model="featuresNoted" rows="4" maxlength="500"
                          class="form-control"
                          placeholder="What is visible in the image — e.g. patchy opacity in right lower zone, blunted costophrenic angle, no pneumothorax..."></textarea>
                        <div class="pup-chiprow">
                          <button type="button" class="pup-chip" v-for="c in signChips" :key="c.text"
                            @click="addChip('featuresNoted', c.text)">{{ c.label }}</button>
                        </div>
                      </div>

                      <div class="pup-field">
                        <div class="pup-field-label">
                          <svg viewBox="0 0 24 24">
                            <path d="M9 18h6"></path>
                            <path d="M10 22h4"></path>
                            <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z"></path>
                          </svg>
                          <label for="inference">Inference</label>
                        </div>
                        <textarea id="inference" v-model="inference" rows="4" maxlength="500" class="form-control"
                          placeholder="What it means clinically — e.g. suggestive of right basal consolidation, correlate with CBC and clinical findings..."></textarea>
                        <div class="pup-chiprow">
                          <button type="button" class="pup-chip" v-for="c in inferenceChips" :key="c.text"
                            @click="addChip('inference', c.text)">{{ c.label }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-bottom pup-foot">
                  <div class="pup-foot-note">
                    <svg viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                    Context is stored with the picture and carried into the consultation note
                  </div>
                  <button type="button" class="btn av-btn-ghost" @click.prevent="closePopUp('goBack')">Cancel</button>

                  <button v-if="uploadfrom == 'genamet' && showbtninsert" class="btn av-btn-primary"
                    @click="insertImage()">Insert</button>

                  <button v-else id="btnSubmit" class="av-btn-primary" :disabled="!hasFile" @click="onsubmitann()">
                    <svg viewBox="0 0 24 24">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Attach to Consultation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <transition name="fade">
      <Messages v-if="isdisplaymsg" :iserror="iserrormsg" :datamessage="sucessmsgtext" v-on:closemsg="closeMessage"
        v-bind:isVisible="isdisplaymsg"></Messages>
    </transition>
  </div>
</template>


<script>
import rest_service from "@/api/rest_service";
import multiselect from "vue-multiselect";
import { mapActions, mapGetters, Store } from "vuex";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import s3api from "@/api/s3api";
import myWorker from "@/config";
import ImageUploadAPI from "@/api/ImageUpload";
import * as markerjs2 from "markerjs2";
import * as cropro from "cropro";
const GenericCache = require("@/common/cache.js").default;
const genCache = new GenericCache("gnmt");

const adddiagnosticcenterurl = "/diagnosticcentre/createdc";
const getalldiagnosticcenterurl = "/diagnosticcentre/getalldc";
const adddiagnosticcentersuburl = "/diagnosticcentre";

export default {
  components: { Messages, multiselect },
  props: [
    "filesToUpload",
    "encounterid",
    "patientid",
    "diagnosticcentername",
    "showmodal",
    "uploadfrom",
    "localimg",
    "updatemodal",
    "parentObj",
    "selectedTestType",
    "uploadednotes",
    "reportweburl",
    "reportweburlpass",
    "reportweburluname",
    "tenantid",
    "webreportid",
    "filescanbeuploaded",
    "webreportcanbeuploaded",
    "maxreportfilecount",
    "maxwebreportcount",
  ],
  data() {
    return {
      // for new design updates
      dragOver: false,
      hasFile: false,
      fileName: '',
      signChips: [
        { label: 'No acute abnormality', text: 'No acute abnormality detected' },
        { label: 'Erythema & swelling', text: 'Localised erythema and swelling' },
        { label: 'Zone opacity', text: 'Opacity noted in lower zone' },
        { label: 'Healing wound', text: 'Healing wound, no discharge' },
      ],
      inferenceChips: [
        { label: 'Correlate clinically', text: 'Correlate clinically' },
        { label: 'Infective aetiology', text: 'Suggestive of infective aetiology' },
        { label: 'Improving vs previous', text: 'Improving compared to previous study' },
        { label: 'Specialist opinion', text: 'Specialist opinion advised' },
      ],
      //for counter
      maxCountinfer: 0,
      maxCountsign: 0,
      remainingCount: 500,
      //
      isCorrupt: true,
      hidesection: true,
      showbtninsert: false,
      imgUrl: null,
      loader: false,
      imagespath: [],
      allimages: [],
      show_modal: false,
      parentproperty: this.parentObj,
      encounter_id: "",
      SelectedSection: "Lab/Scan Reports",
      showWebReportModal: false,
      files: [],
      oldFile: [],
      accept: "image/png,image/gif,image/jpeg,image/webp,application/pdf",
      // extensions: 'gif,jpg,jpeg,png,webp,pdf',
      extensions: ["gif", "jpg", "jpeg", "png", "webp", "pdf"],
      //extensions: /\.(gif|jpe?g|png|webp|pdf)$/i,
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: "fileUploader",
      postAction: "/upload/post",
      putAction: "/upload/put",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: false,
      isOption: false,
      addData: {
        show: false,
        name: "",
        type: "",
        content: "",
      },
      editFile: {
        show: false,
        name: "",
      },
      //Pop Up
      PopupVisible: false,
      PopupVisible_prop: false,

      //Keep reports in user albums
      folderName: "",
      modifiedById: "",
      modifiedByName: "",
      tenantId: "",
      encounterId: " ",
      imgfilename: "",
      visit_encounterDate: null,
      encounterNumber: null,
      //ReportType
      reportType: "",
      testType: "",
      //Report Type
      report_types: [
        {
          report_type: "Lab test",
          value: "labReport",
          selected: true,
        },
        {
          report_type: "Scan test",
          value: "scanReport",
          selected: false,
        },
        {
          report_type: "Others",
          value: "otherReport",
          selected: false,
        },
      ],
      selected_report_type: {},
      //Test Types
      lab_test_types: [
        {
          test_name: "Allergy tests",
          selected: false,
        },
        {
          test_name: "Blood tests",
          selected: false,
        },
        {
          test_name: "Bone Density",
          selected: false,
        },
        {
          test_name: "Urine test",
          selected: false,
        },
      ],
      scan_test_types: [
        {
          test_name: "CT scan",
          selected: false,
        },
        {
          test_name: "ECG",
          selected: false,
        },
        {
          test_name: "Ultrasound",
          selected: false,
        },
        {
          test_name: "X Ray",
          selected: true,
        },
      ],
      other_test_types: [
        {
          test_name: "Prescription",
          selected: false,
        },
        {
          test_name: "None",
          selected: false,
        },
      ],
      selected_test_type: {},
      selected_reportSubmitMethod: "",
      report_notes: "",
      reportWebsiteUrl: "",
      reportWebsiteUname: "",
      reportWebsitePass: "",
      CustomerTestReportsModel: {},
      CustomerViewModel: [],

      //AWS
      bucketName: "",
      bucket: "",
      foldername: "",
      uploadFlag: true,
      deleteFlag: false,

      //Download Url
      fileUrl: [],
      uploadedFileNames: [],
      //processedFileNames: [],
      report_type: "Lab Test",
      stringToBeCropped: "",
      alreadyUploaded: false,

      //Field Validation
      validated: false,
      fileCount: 0,
      validateReportType: true,
      validateTestType: true,
      //View/Download file
      viewItem: false,
      downLoadItem: false,
      //Update Window is same as Edit Window
      updateModal: false,
      saveContinueBtnTxt: "Save & continue",
      saveCloseBtnTxt: "Save & close",
      editWindowText: "Edit report",
      uploadWindowText: "Upload report",
      editObject: {},
      disabledLabTestSelection: true,
      disabledLabScanSelection: true,

      disabledWebUrl: true,
      disabledWebUserName: true,
      disabledWebPass: true,
      validWebUrl: [true],
      validWebUserName: true,
      validWebUserPass: true,
      validFileExt: true,
      validFileSize: true,
      validFileCount: true,
      validWebReportCount: true,
      //Min username length
      minWebReportUsernameLength: 3,
      minWebReportPassLength: 1,
      alertMessage: null,
      popSaveUpwindowFlag: false,
      alertpopupaction: "",
      recordToDelete: {},
      updateType: "",
      saveType: "",
      updateFlag: false,
      saveFlag: false,
      fileNamesToBeUploadedArr: [],
      fileNamesSuccessfullyUploadedArr: [],
      uploadedFilesNameList: [],
      selectedFiles: [],
      diagnostic_center_name: "",
      role_unique_id: "",
      uploaded_notes: "",
      uploaded_webUrl: "",
      uploaded_webUrlUname: "",
      uploaded_webUrlPass: "",
      authenticationToken: "",
      show_add_diatgnosticCenter: false,
      finalDiagnosticList: [],
      selectedDiagCenter: "",
      selectedDiagCenterTemp: "",
      showNote: false,
      showAddDiagBtn: [false],
      shouldGoToShowClosePopUp: true,
      isdisplaymsg: false,
      sucessmsgtext: "",
      editObjLoaded: false,
      toBeUploadObjLoaded: false,
      showloader: false,
      tempFileList: [],
      datatransferobj: new DataTransfer(),
      webReportDetailsArr: [
        {
          reportWebsiteUrl: "",
          reportWebsiteUname: "",
          reportWebsitePass: "",
          validWebsiteUrl: true,
          selectedDiagCenter: "",
          diagnostic_center_name: "",
          showAddDiagBtn: false,
          show_add_diatgnosticCenter: false,
          duplicateEntry: false,
          webReportId: "",
        },
      ],
      iserrormsg: false,
      browseBtnTxt: "Select files",
      filecountcanbeuploaded: 0,
      webreportcountcanbeuploaded: 0,
      totalcharallowedfornote: 250,
      totaltypedchar: 0,
      duplicateUrlArrIndexes: [],
      categorylist: [],
      selectedimageCategory: null,
      featuresNoted: "",
      inference: ""
    };
  },
  created() {
    if (localStorage.loggedInUserInfo) {
      this.modifiedById = JSON.parse(localStorage.loggedInUserInfo).unique_id;
      this.modifiedByName = JSON.parse(
        localStorage.loggedInUserInfo
      ).first_name;
      if (JSON.parse(localStorage.loggedInUserInfo).last_name) {
        this.modifiedByName +=
          " " + JSON.parse(localStorage.loggedInUserInfo).last_name;
      }
      this.tenantId = localStorage.tenantid;
      this.role_unique_id = JSON.parse(localStorage.loggedInUserInfo).role
        ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          : ""
        : "";
      this.encounterId = " "; //this.guid();
      if (this.modifiedById) {
        //this.ac_get_patientTestReports(this.modifiedById);
      }
      if (localStorage.accesstoken) {
        this.authenticationToken = localStorage.accesstoken;
      }
      this.PopupVisible_prop = true;
      this.PopupVisible = true;
    }
    this.getDiagnosticCenterList();

    this.GetImages();
    // Listen for the setDefaultCategory event
    this.$parent.$on('setDefaultCategory', this.setDefaultCategory);

    // this.previewFiles();
    // if(this.localimg!=null&&this.uploadfrom!="genamet"){

    $("#imgPreview").attr("src", this.localimg);
    // this.previewFiles(this.localimg);
    //  }
  },

  beforeDestroy() {
    // Clean up the event listener
    this.$parent.$off('setDefaultCategory');

  },
  mounted() {
    /**
     * JQUERY
     */
    //$(document).on("click", ".thumbnail", function (e) {
    //  debugger;
    // const imgUrl = $(this).children("img").prop("src");
    // this.imgUrl = imgUrl;
    //   $("#editor").show();
    //   $("#btnSubmit").show();
    //   $("#imgPreview").attr("src", imgUrl);
    //  });

    $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
    // $("#app").css({ height: $(window).height() - 100 + "px" });
    // $("#app").height($(document).height());

    $("#searchbar .search-label").on("click", function (e) {
      e.preventDefault();
      $("#searchbar").toggleClass("collapsed");
    });

    $(window).on("load", function () {
      $(".sector-select")
        .change(function () {
          if ($(this).val() != "default value") {
            $(this).addClass("select_validate");
          } else {
            $(this).removeClass("select_validate");
          }
        })
        .trigger("change");
    });

    $(".save-category").click(function () {
      $(".add-category-part").slideUp();
      $(".add-category-btn").removeClass("open");
    });
  },
  methods: {
    ...mapActions([
      //"ac_uploadToS3bucket",
      "ac_getFromS3Bucket",
      "ac_patient_web_reports_save",
      "ac_get_patientTestReports",
      "ac_update_patientTestReports",
      "ac_delete_patientTestReports",
      "ac_update_reset_patientTestReports",
    ]),
    pupChoose() { this.$refs.fileInput.click(); },

    pupDropFile(e) {
      this.dragOver = false;
      const files = e.dataTransfer && e.dataTransfer.files;
      if (!files || !files.length) return;
      this.$refs.fileInput.files = files;       // so previewFiles sees it
      this.onFileChosen({ target: this.$refs.fileInput });
    },

    onFileChosen(e) {
      this.previewFiles(e);                      // your existing logic
      const f = e.target.files && e.target.files[0];
      this.hasFile = !!f && this.validFileExt && this.validFileSize;
      this.fileName = this.hasFile ? f.name : '';
    },

    addChip(field, text) {
      const cur = (this[field] || '').trim();
      if (cur.includes(text)) return;
      this[field] = (cur ? cur + '; ' + text : text).slice(0, 500);
    },
    //aj
    setDefaultCategory(category) {
      this.selectedimageCategory = { category: category };
      this.setall(); // Call setall to apply the active class
      this.$nextTick(() => {
        // Scroll to the "All" category
        const allCategoryElement = document.querySelector('.selectAll');
        if (allCategoryElement) {
          allCategoryElement.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest'
          });
        }
      });
    },

    setall() { this.selectedimageCategory = { category: "All" }; },
    setcategory(item) { this.selectedimageCategory = { category: item }; },


    handleInput() {

      this.showSuggestions = true;
    },
    selectSuggestion(suggestion) {

      this.imagesearch = suggestion;
      this.showSuggestions = false;
    },
    imageLoadError() {
      $("#fileUpload").val('');
      this.Clearall();
    },
    resetValidation() {
      this.validFileExt = true;
      this.validFileSize = true;
    },
    previewFiles(event) {
      let self = this;
      self.isCorrupt = true;
      self.hasFile = false;
      self.fileName = "";
      const file = event.target.files[0];

      // Reset validation flags
      self.validFileExt = true;
      self.validFileSize = true;

      // If no file selected stop
      if (!file) return;

      // EXTENSION VALIDATION
      const allowedExt = ["gif", "jpg", "jpeg", "png", "webp"];
      const ext = file.name.split(".").pop().toLowerCase();

      if (!allowedExt.includes(ext)) {
        self.validFileExt = false;
      }

      // SIZE VALIDATION (< 5 MB allowed)
      const MAX_SIZE_BYTES = 4.76837 * 1024 * 1024; // 4.999..mb

      if (file.size >= MAX_SIZE_BYTES) {
        self.validFileSize = false;
      }

      // If any validation fails → show error & stop
      if (!self.validFileExt || !self.validFileSize) {
        $("#fileUpload").val("");
        $("#editor").hide();
        $("#btnSubmit").hide();
        return;
      }

      // CORRUPTED IMAGE CHECK
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const image = new Image();

        image.onerror = () => {
          self.isCorrupt = false;
          $("#fileUpload").val("");
          $("#editor").hide();
          $("#btnSubmit").hide();
        };

        image.onload = () => {
          if (self.isCorrupt) {
            $("#editor").show();
            $("#btnSubmit").show();
            $("#imgPreview").attr("src", fileReader.result);
            self.hasFile = true;
            self.fileName = file.name;
          }
        };

        image.src = fileReader.result;
      };

      fileReader.readAsDataURL(file);
    },
    Clearall() {
      this.selectedimageCategory = null;
      this.imgUrl = null;
      this.hidesection = true;
      this.featuresNoted = "";
      this.inference = "";
      this.hasFile = false;
      this.fileName = "";
      this.dragOver = false;
      this.validFileExt = true;
      this.validFileSize = true;
      $("#editor").hide();
      $("#btnSubmit").hide();
      $("#fileUpload").val('');
    },
    // setall() {
    //   this.selectedimageCategory = { category: "All" };
    //   $(".selectAll").toggleClass("active");
    //   const button = document.querySelector(".selectAll");
    //   const isActive = button.classList.contains("active");

    //   if (isActive == true) {
    //     // categorysel
    //     $(".categorysel").removeClass("active");
    //     $(".selectAll").addClass("active");
    //   }
    // },
    // setcategory(item) {
    //   this.selectedimageCategory = { category: item };
    //   $(".select" + item).toggleClass("active");
    //   const button = document.querySelector(".select" + item);
    //   const isActive = button.classList.contains("active");

    //   if (isActive == true) {
    //     // categorysel
    //     $(".categorysel").removeClass("active");
    //     $(".select" + item).addClass("active");
    //   }
    // },
    insertImage() {
      if (this.imgUrl != null) {
        this.hidesection = false;
        this.hasFile = true;
        this.fileName = "Genamet image"; 
        $("#editor").show();
        //$("#btnSubmit").show();
        $("#imgPreview").attr("src", this.imgUrl);
        this.showbtninsert = false;
      }

    },

    onsubmitann() {
      this.loader = true;
      if (sessionStorage.getItem("encounterdetails")) {
        var encounData = JSON.parse(sessionStorage.getItem("encounterdetails"));
        this.encounterNumber = encounData.patient_encounter_number;
        this.visit_encounterDate = encounData.created_date;
      }
      var patient_encounter_number = this.encounterNumber;
      var customer_id = this.patientid;
      var encounter_id = this.encounterid;

      // var formData = new FormData();
      var updatedFile = $("#imgPreview").prop("src");
      let base64encoded = updatedFile.toString();
      const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
      base64encoded = base64encoded.substring(sIndex);
      let contentTypeParts = updatedFile.toString().split(";")[0].split(":");
      let contentType = "";
      if (contentTypeParts.length > 1) {
        contentType = contentTypeParts[1];
      }
      // formData.append('category', 'Annotated');
      // formData.append('Url', base64encoded);
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      //var api_url = "http://localhost:49517/api/v1/Annotate/Saveann";
      var api_url = process.env.VUE_APP_PROVIDERPORTAL_BASE_URL + "/Annotate/Saveann";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.request({
        method: "post",
        url: api_url,
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/S3Proxy",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        data: {
          Url: base64encoded,
          contentType: contentType,
          category: "Annotated",
          encounterDate: new Date().toISOString(),
          patient_encounter_number: patient_encounter_number,
          encounter_id: encounter_id,
          customer_id: customer_id,
          created_by: loggedin_user_unique_id,
          featuresNoted: this.featuresNoted,
          inference: this.inference

        },
      })
        .then((response) => {
          this.loader = false;
          this.sucessmsgtext = "Upload complete. Please wait a few minutes to view it on the consultation timeline.";
          this.isdisplaymsg = true;
          setTimeout((xy) => { this.closeMessage(); }, 5000);
          this.Clearall();
          this.closePopUp("goBack");
          this.$parent.getannotatedImagesbycustomer();
        })
        .catch((error) => {
          this.loader = false;    // <-- FIXED
          console.error("Upload error:", error);
          // Optional error message
          this.sucessmsgtext = "Upload failed. Large files may not be supported. Maximum upload size is 5 MB.";
          this.isdisplaymsg = true;
          setTimeout(() => this.closeMessage(), 5000);
        });
    },
    showCropArea() {

      const target = document.getElementById("imgPreview");
      const cropArea = new cropro.CropArea(target);
      cropArea.displayMode = "popup";
      cropArea.styles.settings.toolbarStyleColorsClassName = 'bg-white';
      cropArea.styles.settings.toolbarButtonStyleColorsClassName =
        'bg-gradient-to-t from-white to-white hover:from-white hover:via-pink-100 hover:to-white fill-current text-pink-300';
      cropArea.styles.settings.toolbarActiveButtonStyleColorsClassName =
        'bg-gradient-to-t from-white to-pink-50 fill-current text-pink-400';
      cropArea.styles.settings.toolbarStraightenerColorsClassName = 'text-pink-300 fill-current';
      cropArea.styles.settings.toolbarBackgroundColor = 'white';
      cropArea.styles.settings.canvasBackgroundColor = 'white';
      cropArea.addRenderEventListener((imgURL) => (target.src = imgURL));
      cropArea.show();
    },
    showMarkerArea() {

      var target = document.getElementById("imgPreview");
      var markerArea = new markerjs2.MarkerArea(target);

      markerArea.settings.displayMode = "popup";
      // enable redo, notes, zoom, and clear buttons (hidden by default)
      markerArea.uiStyleSettings.redoButtonVisible = true;
      markerArea.uiStyleSettings.notesButtonVisible = true;
      markerArea.uiStyleSettings.zoomButtonVisible = true;
      markerArea.uiStyleSettings.zoomOutButtonVisible = true;
      markerArea.uiStyleSettings.clearButtonVisible = true;
      markerArea.uiStyleSettings.rotateButtonVisible = true;

      markerArea.uiStyleSettings.toolbarStyleColorsClassName = 'bg-white';
      markerArea.uiStyleSettings.toolbarButtonStyleColorsClassName =
        'bg-gradient-to-t from-white to-white hover:from-white hover:to-pink-50 fill-current text-pink-300';
      markerArea.uiStyleSettings.toolbarActiveButtonStyleColorsClassName =
        'bg-gradient-to-t from-pink-100 via-white to-white fill-current text-pink-400';
      markerArea.uiStyleSettings.toolbarOverflowBlockStyleColorsClassName = "bg-white";

      markerArea.uiStyleSettings.toolboxColor = '#F472B6',
        markerArea.uiStyleSettings.toolboxAccentColor = '#BE185D',
        markerArea.uiStyleSettings.toolboxStyleColorsClassName = 'bg-white';
      markerArea.uiStyleSettings.toolboxButtonRowStyleColorsClassName = 'bg-white';
      markerArea.uiStyleSettings.toolboxPanelRowStyleColorsClassName =
        'bg-pink-100 bg-opacity-90 fill-current text-pink-400';
      markerArea.uiStyleSettings.toolboxButtonStyleColorsClassName =
        'bg-gradient-to-t from-white to-white hover:from-white hover:to-pink-50 fill-current text-pink-300';
      markerArea.uiStyleSettings.toolboxActiveButtonStyleColorsClassName =
        'bg-gradient-to-b from-pink-100 to-white fill-current text-pink-400';
      // this.parentObj.$data.showannModal = false;

      markerArea.addEventListener("render", (event) => {

        var source = event.dataUrl;
        target.src = source;
      });
      markerArea.show();
    },
    GetImages() {
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url = process.env.VUE_APP_PROVIDERPORTAL_BASE_URL + "/S3Proxy/GetAllImages";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.get(api_url, {
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/S3Proxy",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        //data: param
      })
        .then((response) => {
          var temparr = [];
          temparr = response.data.result;
          this.imagespath = temparr;
          if (this.selectedimageCategory) this.selectedimageCategory = { ...this.selectedimageCategory };
          var cattemp = [];
          this.imagespath.forEach((ele) => {
            cattemp.push(ele.category);
          });
          //   this.categorylist=this.imagespath;
          this.categorylist = [];
          this.imagespath.forEach((ele) => {
            if (this.categorylist.length > 0) {
              var check = true;
              this.categorylist.forEach((cat) => {
                if (cat.category == ele.category) {
                  check = false;
                }
              });
              if (check == true) {
                this.categorylist.push(ele);
              }
            } else {
              this.categorylist.push(ele);
            }
          });
        })
        .catch(function (error) {
          return error;
        })
        .finally(() => {
          this.imagespath.forEach((ele) => {

            var authenticationToken = "";
            var role_unique_id = "";
            var loggeedin_userinfo = "";
            var loggedin_user_unique_id = "";
            var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
            var api_url =
              process.env.VUE_APP_PROVIDERPORTAL_BASE_URL + "/Annotate/GetAllImagebase64/" + ele.unique_id;
            // var api_url ="http://localhost:49517/api/v1/Annotate/GetAllImagebase64/"+ele.unique_id;
            if (window.localStorage.getItem("accesstoken")) {
              authenticationToken = window.localStorage.getItem("accesstoken");
            }
            var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

            if (provider) {
              if (provider.role) {
                role_unique_id = provider.role.unique_id;
                loggedin_user_unique_id = provider.unique_id;
              }
            }
            return Axios.get(api_url, {
              headers: {
                x_tenant_id: tenantId,
                role_unique_id: role_unique_id,
                route_entity_name: "/S3Proxy",
                loggedin_user_unique_id: loggedin_user_unique_id,
                Authorization: authenticationToken,
              }
              //"Accept-Encoding": "gzip"
              // },//IN LOCAL UNCOMMENT BELOW LINE
              // responseType: "blob", 
              //data: param
            })
              .then((response) => {

                //IN LOCAL UNCOMMENT
                // var reader = new FileReader();
                // reader.onload = () => {
                //   const base64String = reader.result;
                //   // Do something with the base64String, such as sending it to a server or using it in your application
                //   console.log(base64String);
                //   ele.url = base64String;
                //   this.allimagebase64.push(base64String);
                // };
                // reader.readAsDataURL(response.data);
                //IN LOCAL UNCOMMENT
                var base64String = "data:application/octet-stream;base64," + response.data;
                this.$set(ele, "url", base64String);
              })
              .catch(function (error) {
                return error;
              })
              .finally(() => {
                var tempimages = this.imagespath;
                // this.allimages = tempimages;
              });
          });
        });
    },
    GetImagesbase64() {
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url =
        process.env.VUE_APP_PROVIDERPORTAL_BASE_URL + "/S3Proxy/GetAllImagebase64/" + id;
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.get(api_url, {
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/S3Proxy",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        //data: param
      })
        .then((response) => {

          var reader = new FileReader();
          reader.readAsDataURL(response.data.result);
          let base64String = reader.result;
          return base64String;
        })
        .catch(function (error) {
          return error;
        });
    },
    getFolderName() {
      this.foldername =
        this.$store.state.helper.patient_s3upload_Folders.reportimageFolder;
    },
    //Reset File
    resetFile() {
      document.getElementById("uploadFile1").value = "";
      this.fileNamesToBeUploadedArr = [];
      this.fileNamesSuccessfullyUploadedArr = [];
      //Empty selected fileList Obj
      // this.files=[];
      // this.datatransferobj=new DataTransfer();
    },



    //Validate File
    validateFile() {
      var fileName = document.getElementById("fileUpload").value;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("fileUpload").files;
      if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(fileName)) {
        $("#fileUpload").val('');
        this.iserrormsg = true;
        this.sucessmsgtext =
          " Upload only image";
        this.isdisplaymsg = true;
        setTimeout((xy) => {
          this.closeMessage();
        }, 5000);
        this.alert("Selected item is not an image");
        return prevent();
      }
      //alert(this.fileCount > this.$store.state.helper.allowedFileSize? "larger":"smaller");
    },
    //Upload File
    uploadFile(mode) {
      if (this.validFileExt && this.validFileSize && this.validFileCount) {
        this.getFolderName();
        //this.processedFileNames = [];
        if (this.tenantId && this.modifiedById && this.modifiedByName) {
          //this.files = document.getElementById("uploadFile1").files;
          console.log("In Upload File ()>>>", this.files);
          this.fileCount = this.files.length;
          ////console.log(this.files);
          if (this.validFileCount) {
            var self = this;
            self.fileUrl = "";
            var corruptedfilearr = [];
            //alert(self.files.length);
            for (var i = 0; i < self.files.length; i++) {
              let file = self.files[i];
              self.fileNamesToBeUploadedArr.push(file.name);
              file.uploadedDatetime = new Date(
                new Date().toUTCString()
              ).getTime();
              file.uploadedById = self.modifiedById;
              file.uploadedByName = self.modifiedByName;
              file.tenantId = self.tenantId;
              file.encounterId = self.encounterId; //Encounter ID
              //console.log("file>>>>>>>>>>>>>>" + i, file);
              let data1;
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
                //console.log("reader.result>>>>>>>>>>>>>>"+i,reader.result);
                if (reader.result && reader.readyState) {
                  data1 = atob(reader.result.split(",")[1]);
                }
                if (data1) {
                  let arr = new Uint8Array(data1.length);
                  for (let i = 0; i < data1.length; i++) {
                    arr[i] = data1.charCodeAt(i);
                  }
                  let filetoUpload = new File([arr], file.name, {
                    type: file.type,
                  });
                  // This is the folder structure on S3: Base_Folder_Name/tenantId/PatientId/FileName.ext
                  let fileInfo = {
                    file: filetoUpload,
                    filename:
                      self.stringToBeCropped +
                      file.name.replace("_", "").replace(/\s/g, ""),
                    folderName: self.foldername,
                  };
                  //console.log("fileInfo " + i, fileInfo);
                  //Upload the file to S3
                  self.uploadedFilesNameList = [];
                  s3api
                    .uploadToS3Bucket(self.tenantId, fileInfo)
                    .then((respo) => {
                      if (respo && respo.data && respo.data.message) {
                        if (
                          respo.data.message !==
                          "File upload failed. File not good!"
                        ) {
                          let fname = "";
                          //let extnsn = respo.data.message.substring(respo.data.message.lastIndexOf('.')+1, respo.data.message.length);
                          if (respo.data.message.length) {
                            if (respo.data.message.split("_")[6]) {
                              fname = respo.data.message.substring(
                                respo.data.message.indexOf(
                                  respo.data.message.split("_")[6]
                                ),
                                respo.data.message.length
                              );
                            } else {
                              fname = respo.data.message;
                            }
                          }
                          let tempobj = {
                            report_actual_name: file.name,
                            report_user_friendly_name: file.name,
                            report_file_key: respo.data.message,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            record_status: true,
                            //diagnostic_center_name: self.diagnostic_center_name,
                            //created_username: self.modifiedByName
                          };
                          self.uploadedFilesNameList.push(tempobj);
                          tempobj = {};
                          self.iserrormsg = false;
                        } else {
                          corruptedfilearr.push(file.name);
                          let tempobj = {
                            report_actual_name: file.name,
                            report_user_friendly_name: respo.data.message,
                            report_file_key: respo.data.message,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            diagnostic_center_name: self.diagnostic_center_name,
                            created_username: self.modifiedByName,
                          };
                          self.uploadedFilesNameList.push(tempobj);
                          self.iserrormsg = true;
                          self.sucessmsgtext =
                            file.name +
                            " is a corrupted file. Could not be uploaded.";
                          self.isdisplaymsg = true;
                          setTimeout((xy) => {
                            self.closeMessage();
                          }, 5000);
                        }
                      }
                    })
                    .finally((zz) => {
                      if (
                        self.uploadedFilesNameList.length === self.files.length
                      ) {
                        self.uploadedFilesNameList =
                          self.uploadedFilesNameList.filter((xx, ind) => {
                            return (
                              xx.report_actual_name !== corruptedfilearr[ind] &&
                              xx.report_file_key !==
                              "File upload failed. File not good!"
                            );
                          });
                        if (
                          self.uploadedFilesNameList &&
                          self.uploadedFilesNameList.length
                        ) {
                          self.isdisplaymsg = false;
                          var multipleFlag =
                            self.uploadedFilesNameList.length > 1
                              ? "Files"
                              : "File";

                          self.CustomerTestReportsModel = {
                            report_type: self.reportType,
                            test_type: self.testType,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            invfilelist: self.uploadedFilesNameList,
                            report_notes: self.report_notes
                              ? self.report_notes
                              : "",
                            // investigation_id: "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",
                            encounter_id: self.encounterid,
                            unread: true,
                          };

                          var encdata = {};
                          var imgData = {};
                          if (sessionStorage.getItem("encounterdetails")) {
                            var encounData = JSON.parse(
                              sessionStorage.getItem("encounterdetails")
                            );
                            self.encounterNumber =
                              encounData.patient_encounter_number;
                            self.visit_encounterDate = encounData.created_date;
                          }

                          encdata.created_userid = self.modifiedById;
                          encdata.created_username = self.modifiedByName;
                          encdata.report_actual_name = file.name;
                          encdata.filelist = self.uploadedFilesNameList;
                          encdata.report_file_key = fileInfo.filename;
                          encdata.report_user_friendly_name = file.name;
                          //encdata.uploaded_date = new Date().toISOString();
                          encdata.patient_encounter_number =
                            self.encounterNumber;
                          encdata.customer_id = self.patientid;
                          encdata.encounter_id = self.encounterid;

                          encdata.visit_date = self.visit_encounterDate;
                          //imgData.last_uploaded_Img_key =respo.data.message;
                          encdata.last_uploaded_Img_key = fileInfo.filename;
                          // self.encounterData.uploadedImageslist.push(encdata);
                          // self.encounterData.last_uploaded_Img_key = imgData.last_uploaded_Img_key;
                          // self.fileCount+=1;
                          if (
                            typeof encdata.report_file_key === "string" &&
                            encdata.report_file_key
                          ) {
                            self.foldername =
                              self.tenantId +
                              self.$store.state.helper.tenant_s3upload_Folders
                                .UploadedImagePath +
                              encdata.report_file_key;
                          }

                          ImageUploadAPI.fileUpload(encdata)
                            .then((categResponse) => {
                              //if (categResponse.length>0) {
                              self.$parent.setViewFileListPopUpData(
                                categResponse
                              );
                              self.closePopUp("goBack");
                              //  self.getimageuploadeddata();
                              //}
                            })
                            .catch((err) => {
                              console.error("Upload Failed! ", err);
                              //self.show_modal = false;
                              self.sucessmsgtext = "File upload failed!";
                              self.iserrormsg = true;
                              self.isdisplaymsg = true;
                              setTimeout((xy) => {
                                self.closeMessage();
                              }, 5000);
                              self.showloader = false;
                            })
                            .finally((zyzy) => {
                              if (corruptedfilearr && corruptedfilearr.length) {
                                let filenames = corruptedfilearr.join();
                                self.sucessmsgtext =
                                  filenames + " - Could not be uploaded.";
                                self.iserrormsg = true;
                                self.isdisplaymsg = false;
                                self.isdisplaymsg = true;
                                setTimeout((xy) => {
                                  self.closeMessage();
                                }, 5000);
                              }
                              if (
                                self.uploadedFilesNameList &&
                                self.uploadedFilesNameList.length
                              ) {
                                let tempuploadedarr = [];
                                self.uploadedFilesNameList.forEach((y) => {
                                  tempuploadedarr.push(y.report_actual_name);
                                });
                                let filenames = tempuploadedarr.join();
                                self.sucessmsgtext = "";
                                self.iserrormsg = false;
                                self.isdisplaymsg = true;
                                self.sucessmsgtext =
                                  filenames + " uploaded successfully";
                                setTimeout((xy) => {
                                  self.closeMessage();
                                }, self.$store.state.helper.msgDisplayTime);
                              }
                            });
                        } else {
                          self.showloader = false;
                        }
                        self.uploadFlag = false;
                        self.showloader = false;
                      }
                    });
                  //};
                  //after upload request save the info into the database
                  self.tempFiles = file.name
                    .replace("_", "")
                    .replace(/\s/g, "");
                }
              };
            }
          }
        }
      } else {
        this.$store.state.helper.st_alert_message = "";
        if (!this.validFileExt) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message = "Invalid file type";
        }
        if (!this.validFileSize) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message =
            "Maximum upload size exceeded.</br>File size should be within 5MB";
        }
        if (!this.validFileExt && !this.validFileSize) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message =
            "Invalid file type.</br>Maximum upload size exceeded.</br>File size should be within 5MB";
        }
      }
    },
    //Save Report Details
    SaveReport(mode, isupdate) {
      //console.log("In SaveReport()---->");
      var self = this;
      self.reportType = "";
      self.testType = "";
      //self.saveFlag = true;
      //self.showloader=true;

      if (this.validFileCount) {
        if (this.validFileExt && this.validFileSize && this.validFileCount) {
          self.showloader = true;
          self.uploadFlag = true;
          var newguid = this.guid1();
          self.stringToBeCropped = (
            self.tenantId +
            "_" +
            self.modifiedById +
            "_" +
            newguid +
            "_"
          ).replace(/\s/g, "");
          self.uploadedFilesNameList = [];
          if (!self.tenantid) {
            console.error("tenant id is missing", self.tenantId);
          }
          self.uploadFile(mode);
        }
      }
    },
    //Save & Continue
    saveReportAndReset() {
      //First Save the File
      this.SaveReport(true);
      this.saveType = "save-reset";
    },
    //Update & close report
    updateReportData(type) {
      //console.log("In UpdateReport()---->");
      if (type === "update-single") {
        this.updateType = type;
      }
      this.updateFlag = true;
      var self = this;
      self.isdisplaymsg = false;
      self.reportType = "";
      self.testType = "";
      if (self.selected_report_type) {
        if (
          self.selected_report_type.value &&
          self.selected_report_type.selected
        ) {
          self.reportType = self.selected_report_type.value;
        }
      }
      if (self.selected_test_type) {
        if (
          self.selected_test_type.test_name &&
          self.selected_test_type.selected
        ) {
          self.testType = self.selected_test_type.test_name;
        }
      }
      if (self.selected_reportSubmitMethod === "_web") {
        if (
          self.reportWebsiteUrl !== "" &&
          self.reportWebsiteUname !== "" &&
          self.reportWebsitePass !== ""
        ) {
          self.CustomerTestReportsModel = {
            report_type: self.reportType,
            test_type: self.testType,
            diagnostic_center_name: self.diagnostic_center_name,
            report_notes: self.report_notes ? self.report_notes : "",
            uploaded_date: new Date().toISOString(),
            created_userid: self.modifiedById,
            report_webUrl: self.reportWebsiteUrl,
            report_webUrlUname: self.reportWebsiteUname,
            report_webUrlPass: self.reportWebsitePass,
            //investigation_id: "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",
            encounter_id: self.encounterid,
          };
          //console.log(self.CustomerTestReportsModel);
          s3api
            .saveInvestigationFileName(
              self.CustomerTestReportsModel,
              self.tenantId,
              self.role_unique_id,
              self.modifiedById
            )
            .then((res) => {
              if (res.data && res.data.result && res.data.result.length) {
                this.updateFlag = false;
                self.closePopUp("goBack");
                self.sucessmsgtext = "Updated successfully";
                self.isdisplaymsg = true;
                setTimeout((xy) => {
                  self.closeMessage();
                }, self.$store.state.helper.msgDisplayTime);
              }
            })
            .finally((zzx) => {
              if (self.parentObj) {
                if (
                  typeof self.parentObj
                    .getinvestigationbyencounteridanduniqueid === "function"
                ) {
                  //self.parentObj.getListFlag = true;
                  self.parentObj.getinvestigationbyencounteridanduniqueid(
                    self.encounterid,
                    "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27"
                  );
                }
              }
            });
        }
      }
    },
    updateReportAndReset(type) {
      if (type === "update-reset") {
        this.updateType = type;
      }
      this.updateReportData(this.updateType);
    },
    resetPopUp() {
      this.reportType = "";
      this.testType = "";
      this.foldername = "";
      this.report_notes = "";
      this.reportWebsiteUrl = "";
      this.reportWebsiteUname = "";
      this.reportWebsitePass = "";
      this.disabledLabTestSelection = true;
      this.disabledScanTestSelection = true;
      this.selected_report_type = {};
      this.CustomerTestReportsModel = {};
      this.selected_test_type = {};
      this.selected_reportSubmitMethod = "";
      this.validateReportType = true;
      this.deleteFlag = false;
      this.uploadFlag = false;
      this.validFileExt = true;
      this.validFileSize = true;
      if (document.getElementById("uploadFile1")) {
        document.getElementById("uploadFile1").value = "";
      }
      this.show_add_diatgnosticCenter = false;
      //this.finalDiagnosticList = [];
      this.selectedDiagCenter = "";
      this.selectedDiagCenterTemp = "";
      this.selectedFiles = [];
      //Empty selected fileList Obj
      this.files = [];
      this.datatransferobj = new DataTransfer();
      //Edit Object One time load Flag
      this.editObjLoaded = false;
      this.toBeUploadObjLoaded = false;
      this.webReportDetailsArr = [
        {
          reportWebsiteUrl: "",
          reportWebsiteUname: "",
          reportWebsitePass: "",
          validWebsiteUrl: true,
          selectedDiagCenter: "",
          diagnostic_center_name: "",
          showAddDiagBtn: false,
          show_add_diatgnosticCenter: false,
          duplicateEntry: false,
          webReportId: "",
        },
      ];
      this.showNote = false;
      this.tempFileList = [];
      //this.$store.state.patient.st_reports = null;
      //this.$store.state.S3Proxy.st_uploadedfile = null;
      //this.$store.state.helper.showAlertMsgPopUP = false;
      // if(this.$refs && this.$refs.alertpopup)
      // {
      //   this.$refs.alertpopup.btnText = "";
      // }
    },
    getBase64(file) {
      ////console.log("Inside getBase64");
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        ////console.log(reader.result);
        return reader.result;
      };
      reader.onerror = function (error) {
        //console.log("Error: ", error);
        return error;
      };
    },

    guid1: function () {
      // http://www.ietf.org/rfc/rfc4122.txt
      var s = [];
      var hexDigits = "0123456789abcdef";
      //var intDigits = "0123456789";
      for (var i = 0; i < 5; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      // s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      // s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },

    getObj(file_name) {
      //var s3key= this.tenantId+this.foldername+this.tenantId+"_"+this.modifiedById+"_VS_CODE_keyboard-shortcuts-windows.pdf";
      var s3key =
        this.tenantId +
        this.foldername +
        this.tenantId +
        "_" +
        this.modifiedById +
        "_" +
        file_name;
      this.ac_getFromS3Bucket(s3key);
    },
    formatDate: function (dt) {
      return (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      );
    },
    getReportType: function () {
      ////console.log(this.selected_report_type);
      if (this.selected_report_type) {
        if (this.selected_report_type.report_type === "Lab test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "labReport";
        }
        if (this.selected_report_type.report_type === "Scan test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "scanReport";
        }
        if (this.selected_report_type.report_type === "Others") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "otherReport";
        }
      }
    },
    getTestType: function () {
      if (this.selected_test_type) {
        if (this.selected_report_type.hasOwnProperty("report_type")) {
          this.selected_test_type.selected = true;
        } else {
          this.validateReportType = false;
          return;
        }
      }
    },
    getUpdateReportType: function () {
      if (this.selected_report_type) {
        if (this.selected_report_type.report_type === "Lab test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "labReport";
          this.selected_test_type.test_name = "";
        }
        if (this.selected_report_type.report_type === "Scan test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "scanReport";
          this.selected_test_type.test_name = "";
        }
        if (this.selected_report_type.report_type === "Others") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "otherReport";
          this.selected_test_type.test_name = "";
        }
      }
    },
    closePopUp: function (item) {
      this.featuresNoted = "";
      this.inference = "";
      this.Clearall();
      this.$store.state.helper.showAlertMsgPopUP = false;
      this.$store.state.helper.st_alert_message = "";
      this.show_modal = false;
      if (item === "fileReport") {
        this.show_modal = false;
        if (this.parentObj.$data.showannModal) {
          this.parentObj.$data.showannModal = false;
        }

        ////console.log("In CLOSE POP UP>>>>>>>>>>>");
        ////console.log(this.$refs);
        // if(this.$refs && this.$refs.alertpopup)
        // {
        //   this.$refs.alertpopup.btnText = "Ok";
        // }
        // this.$store.state.helper.showAlertMsgPopUP = true;
        // //console.log(this.$store.state.helper.showAlertMsgPopUP);
      }
      if (item === "goBack") {
        this.shouldGoToShowClosePopUp = false;
        this.show_modal = false;
        this.updateModal = false;

        //console.log("this.parentObj.$data.showModal>>>",this.parentObj.$data);
        //Following is for dashboard.vue data
        if (this.parentObj.$data.showannModal) {
          this.parentObj.$data.showannModal = false;
        }
        if (this.parentObj.$data.showUpdateModal) {
          this.parentObj.$data.showUpdateModal = false;
        }
      }
      if (item === "webReport") {
        this.showWebReportModal = false;
      }
      if (item === "editReport") {
        this.updateModal = false;
        this.show_modal = false;
      }
      //If Save & continue don't close the popup, instead reset it.
      // if(this.saveType === 'save-reset')
      // {
      //   this.resetPopUp();
      //   this.printValue();
      // }
    },
    viewFile: function (item, itemtype, report_Type) {
      if (typeof item === "string" && itemtype === "uploadedfile") {
        if (report_Type === "labReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .latReportDownloadPath +
            item;
        }
        if (report_Type === "scanReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .scanReportDownloadPath +
            item;
        }
        if (report_Type === "otherReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
            item;
        }
        //alert(this.foldername);
        this.ac_getFromS3Bucket(this.foldername);
        this.viewItem = true;
        this.downLoadItem = false;
      } else if (typeof item === "object" && itemtype === "webReport") {
        //alert(item.report_webUrl+"->"+item.report_webUrlUname+"->"+item.report_webUrlPass);
        this.reportWebsiteUrl = item.report_webUrl;
        this.reportWebsiteUname = item.report_webUrlUname;
        this.reportWebsitePass = item.report_webUrlPass;
        this.showWebReportModal = true;
      }
    },
    downloadFile: function (item, itemtype, report_Type) {
      if (
        typeof item === "string" &&
        itemtype === "uploadedfile" &&
        item.length > 0
      ) {
        if (report_Type === "labReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .latReportDownloadPath +
            item;
        }
        if (report_Type === "scanReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .scanReportDownloadPath +
            item;
        }
        this.ac_getFromS3Bucket(this.foldername);
        this.viewItem = false;
        this.downLoadItem = true;
      }
    },
    onClickChild: function (value) {
      this.PopupVisible_prop = value;
    },
    visitSite: function () {
      var win = window.open(this.reportWebsiteUrl, "_blank");
      if (win) {
        //Browser has allowed it to be opened
        win.focus();
      } else {
        //Browser has blocked it
        //alert("Please allow popups for this website");
        self.sucessmsgtext = "Please allow popups for this website";
        self.isdisplaymsg = true;
      }
    },
    updateItem: function (item) {
      //console.log(item);
      //this.resetPopUp();
      this.editObject = item;
      this.updateModal = true;
      this.selected_reportSubmitMethod = "_web";
      this.editWindowText = "Edit report";
      this.uploadWindowText = "Upload report";
      this.show_modal = false;
      this.saveContinueBtnTxt = "Update";
      this.selected_report_type = {};
      this.selected_test_type = {};
      var arr = [];
      if (item) {
        if (
          item.report_webUrl &&
          item.report_webUrlUname &&
          item.report_webUrlPass
        ) {
          if (item.report_type) {
            if (item.report_type === "labReport") {
              this.selected_report_type = {
                report_type: "Lab test",
                value: item.report_type,
                selected: true,
              };
            } else if (item.report_type === "scanReport") {
              this.selected_report_type = {
                report_type: "Scan test",
                value: item.report_type,
                selected: true,
              };
            } else if (item.report_type === "otherReport") {
              this.selected_report_type = {
                report_type: "Others",
                value: item.report_type,
                selected: true,
              };
            }
          }
          if (item.report_type === "labReport") {
            arr = this.lab_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          if (item.report_type === "scanReport") {
            arr = this.scan_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          if (item.report_type === "otherReport") {
            arr = this.other_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          this.report_notes = item.report_notes ? item.report_notes : "";

          if (
            item.report_webUrl &&
            item.report_webUrl.length > 0 &&
            item.report_webUrlUname &&
            item.report_webUrlPass
          ) {
            this.selected_reportSubmitMethod = "_web";
            this.reportWebsiteUrl = item.report_webUrl;
            this.reportWebsiteUname = item.report_webUrlUname;
            this.reportWebsitePass = item.report_webUrlPass;
            //this.selectedUniqueId = item.unique_id;
          }
          if (self.selected_reportSubmitMethod === "_web") {
            if (
              self.reportWebsiteUrl !== "" &&
              self.reportWebsiteUname !== "" &&
              self.reportWebsitePass !== ""
            ) {
              self.validated = true;
              /*self.CustomerTestReportsModel={
                      customer_Id: self.modifiedById,
                      tenant_id: self.tenantId,
                      encounter_Id: " ", //this needs to be a space or any string value
                      report_type: self.reportType,
                      test_type: self.testType,
                      created_date: new Date().toISOString(),
                      created_userid: self.modifiedById,
                      record_status: true,
                      report_notes: self.report_notes? self.report_notes : "",
                      report_webUrl: self.reportWebsiteUrl,
                      report_webUrlUname: self.reportWebsiteUname,
                      report_webUrlPass: self.reportWebsitePass,
                  };*/
            }
            setTimeout(() => {
              ////console.log(self.CustomerTestReportsModel);
              //s3api.ac_patient_web_reports_save(self.CustomerTestReportsModel);
            }, 0);
            //to update the list
            this.CustomerViewModel.unshift(this.CustomerTestReportsModel);
          }
        }
      }
    },
    changeSource: function (item) {
      if (this.updateModal) {
        this.show_modal = false;
        if (this.selected_reportSubmitMethod === item) {
          var respo = confirm("Do you want to change the resource type?");
          if (respo == true) {
            this.show_modal = false;
            this.selected_reportSubmitMethod = "_desktop";
          } else {
            this.show_modal = false;
            this.selected_reportSubmitMethod = "_web";
          }
        }
      }
    },
    deleteReport: function (item) {
      if (item) {
        if (item.customer_Id === this.modifiedById) {
          this.deleteFlag = true;
          this.recordToDelete = item;
          this.$store.state.helper.showAlertMsgPopUP = false;
          this.$store.state.helper.st_alert_message = "";
          this.alertpopupaction = "delete-report";
          this.$store.state.helper.showDelConfirmPopUp = true;
          //this.ac_delete_patientTestReports(item);
        }
      }
    },
    confirmDelete() {
      if (this.alertpopupaction === "delete-report") {
        this.ac_delete_patientTestReports(this.recordToDelete);
      }
    },
    toDashboard: function () {
      this.$router.push("/dashboard");
    },
    isValidURL: function (str) {
      var regexp =
        /^(?:(?:https?|ftp):\/\/)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (regexp.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    printValue() {
      // //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      // //console.log("1",this.reportType);
      // //console.log("2",this.testType);
      // //console.log("3",this.foldername);
      // //console.log("4",this.report_notes);
      // //console.log("5",this.reportWebsiteUrl);
      // //console.log("6",this.reportWebsiteUname);
      // //console.log("7",this.reportWebsitePass);
      // //console.log("8",this.disabledLabTestSelection);
      // //console.log("10",this.disabledScanTestSelection);
      // //console.log("11",this.selected_report_type);
      // //console.log("12",this.CustomerTestReportsModel);
      // //console.log("13",this.selected_test_type);
      // //console.log("14",this.selected_reportSubmitMethod);
      // //console.log("15",this.validateReportType);
      // //console.log("16",this.deleteFlag);
      // //console.log("17",this.uploadFlag);
    },
    show_add_diatgnosticCenter_part() {
      this.show_add_diatgnosticCenter = this.show_add_diatgnosticCenter
        ? false
        : true;
    },
    addDiagnostic(diagData) {
      //console.log(rest_service.baseURL + adddiagnosticcenterurl);
      var self = this;
      var diagObj = {
        name: diagData,
        created_by_enitity_type: this.role_unique_id,
        created_by: this.modifiedById,
        created_date: new Date().toISOString(),
      };
      //console.log("diagData>>>>", diagData);
      self.showloader = true;
      Axios.request(rest_service.baseURL + adddiagnosticcenterurl, {
        method: "post",
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: adddiagnosticcentersuburl,
          loggedin_user_unique_id: this.modifiedById,
          Authorization: this.authenticationToken,
        },
        data: diagObj,
      })
        .then((xy) => {
          if (xy && xy.data && xy.data.result && xy.data.result) {
            //console.log("AFTER DIAGNOSTIC DATA ADDITION>>>>>>", xy);
            self.finalDiagnosticList = xy.data.result;
            xy.data.result.forEach((z) => {
              if (z.name === diagData) {
                self.selectedDiagCenter = z.unique_id;
              }
            });
            self.selectedDiagCenterTemp = "";
            self.show_add_diatgnosticCenter = false;
            self.showloader = false;
          }
        })
        .catch(function (err) {
          console.error(err);
          self.showloader = false;
        });
    },
    getDiagnosticCenterList() {
      var self = this;
      var diagnosticurl = rest_service.baseURL + getalldiagnosticcenterurl;
      var diagnosticHeaders = {
        tenantid: this.tenantId,
        role_unique_id: this.role_unique_id,
        loggedin_user_unique_id: this.modifiedById,
        entity_name: adddiagnosticcentersuburl,
        accesstoken: this.authenticationToken,
        url: diagnosticurl,
      };
      if (!localStorage.getItem("diagnosticcenterlist")) {
        var disgnosticmsg = JSON.stringify(diagnosticHeaders);
        myWorker
          .send(disgnosticmsg)
          .then((xy) => {
            if (xy && xy.result) {
              //console.log("ALL DIAGNOSTIC CENTER NAME>>>>>>", xy);
              self.finalDiagnosticList = xy.result;
              localStorage.setItem(
                "diagnosticcenterlist",
                JSON.stringify(self.finalDiagnosticList)
              );
            }
          })
          .catch(function (err) {
            console.error(err);
          });
      } else {
        self.finalDiagnosticList = JSON.parse(
          localStorage.getItem("diagnosticcenterlist")
        );
      }
    },
    getSelectedDiagnosticCenter(item) {
      if (item) {
        //diagnostic_center_name
        this.finalDiagnosticList.forEach((x) => {
          if (item === "OTHERS") {
            this.showAddDiagBtn[index] = true;
          } else if (x.unique_id === item) {
            this.showAddDiagBtn = false;
            this.diagnostic_center_name = x.name;
          }
        });
        if (self.selected_reportSubmitMethod === "web") {
        }
      }
    },
    getIndexedSelectedDiagnosticCenter(item, index) {
      if (item && item.selectedDiagCenter) {
        //diagnostic_center_name
        this.finalDiagnosticList.forEach((x) => {
          if (item.selectedDiagCenter === "OTHERS") {
            item.showAddDiagBtn = true;
          } else if (x.unique_id === item.selectedDiagCenter) {
            item.showAddDiagBtn = false;
            item.diagnostic_center_name = x.name;
          }
        });
      }
    },
    show_add_indexed_diatgnosticCenter_part(item, index) {
      item.show_add_diatgnosticCenter = item.show_add_diatgnosticCenter
        ? false
        : true;
    },
    addIndexedDiagnostic(item, diagData) {
      //console.log(rest_service.baseURL + adddiagnosticcenterurl);
      var self = this;
      var diagObj = {
        name: diagData,
        created_by_enitity_type: this.role_unique_id,
        created_by: this.modifiedById,
        created_date: new Date().toISOString(),
      };
      //console.log("diagData>>>>", diagData);

      Axios.request(rest_service.baseURL + adddiagnosticcenterurl, {
        method: "post",
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: adddiagnosticcentersuburl,
          loggedin_user_unique_id: this.modifiedById,
          Authorization: this.authenticationToken,
        },
        data: diagObj,
      })
        .then((xy) => {
          if (xy && xy.data && xy.data.result && xy.data.result) {
            //console.log("AFTER DIAGNOSTIC DATA ADDITION>>>>>>", xy);
            self.finalDiagnosticList = xy.data.result;
            xy.data.result.forEach((z) => {
              if (z.name === diagData) {
                item.selectedDiagCenter = z.unique_id;
              }
            });
            self.selectedDiagCenterTemp = "";
            item.show_add_diatgnosticCenter = false;
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    showHideNote() {
      this.showNote = !this.showNote;
      $(".add-categoryst").slideToggle();
      $("#add_category i.material-icons").toggleClass("open");
    },
    countdown() {
      this.remainingCount = this.maxCount - this.notes.length;
    },
    removeFile(items) {
      var dt = new DataTransfer();
      var tempFiles = this.files;
      var self = this;
      Array.from(tempFiles).forEach(function (s, index) {
        if (s.guid !== items.id) {
          //console.log(self.files[index]);
          dt.items.add(self.files[index]);
        }
      });
      self.datatransferobj = new DataTransfer();
      self.datatransferobj = dt;
      self.files = self.datatransferobj.files;
      self.fileCount = self.files.length;
      if (this.fileCount > 0) {
        this.browseBtnTxt = "Add files";
      } else {
        this.browseBtnTxt = "Select files";
      }
      self.selectedFiles = self.selectedFiles.filter((xy) => {
        return xy.id !== items.id;
      });
      // if((self.fileCount < self.filescanbeuploaded) && (self.filecountcanbeuploaded < self.filescanbeuploaded)){
      //   self.filecountcanbeuploaded += 1;
      // }
      // else{
      //   if(self.fileCount < self.filecountcanbeuploaded){
      //     self.filecountcanbeuploaded = self.filecountcanbeuploaded - self.fileCount;
      //   }
      //   else{
      //     self.filecountcanbeuploaded = 0;
      //   }
      // }
      self.filecountcanbeuploaded =
        self.filescanbeuploaded - self.fileCount >= 0
          ? self.filescanbeuploaded - self.fileCount
          : 0;

      self.validFileCount =
        self.fileCount + self.filecountcanbeuploaded <= self.filescanbeuploaded
          ? true
          : false;
      console.log("After File Removed>>>", self.files, self.selectedFiles);
    },
    closeMessage() {
      this.isdisplaymsg = false;
      this.iserrormsg = false;
    },
    //To generate random GUID (guid ans s4)
    guid() {
      return "ss-s-s-s-sss".replace(/s/g, this.s4);
    },
    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },
    addfields() {
      //webReportDetailsArr
      console.log("WEBREPORT DETAILS>>>>", this.webReportDetailsArr);
      if (this.show_modal) {
        var temp = {
          reportWebsiteUrl: "",
          reportWebsiteUname: "",
          reportWebsitePass: "",
          validWebsiteUrl: true,
          selectedDiagCenter: "",
          diagnostic_center_name: "",
          showAddDiagBtn: false,
          show_add_diatgnosticCenter: false,
          duplicateEntry: false,
          webReportId: "",
        };
        //Validate the next entry
        if (
          this.isValidURL(
            this.webReportDetailsArr[this.webReportDetailsArr.length - 1]
              .reportWebsiteUrl
          ) &&
          !this.webReportDetailsArr[this.webReportDetailsArr.length - 1]
            .duplicateEntry
        ) {
          this.webreportcountcanbeuploaded =
            this.webreportcanbeuploaded -
              (this.webReportDetailsArr.length + 1) >=
              0
              ? this.webreportcanbeuploaded -
              (this.webReportDetailsArr.length + 1)
              : 0;
          // if(this.webReportDetailsArr.length===(this.webreportcanbeuploaded-1)){
          //   this.webreportcountcanbeuploaded = this.webreportcountcanbeuploaded == 0? 1:0;
          // }
          if (this.webreportcountcanbeuploaded >= 0) {
            this.webReportDetailsArr.push(temp);
          }
        }
      }
      if (this.updateModal) {
        var temp = {
          reportWebsiteUrl: "",
          reportWebsiteUname: "",
          reportWebsitePass: "",
          validWebsiteUrl: true,
          selectedDiagCenter: "",
          diagnostic_center_name: "",
          showAddDiagBtn: false,
          show_add_diatgnosticCenter: false,
          duplicateEntry: false,
        };
        this.webReportDetailsArr.push(temp);
      }
      //this.validWebUrl.push(true);
      console.log("After Adding Field>>>", this.webReportDetailsArr);
    },
    removefields(i) {
      this.webreportcountcanbeuploaded =
        this.webreportcanbeuploaded - (this.webReportDetailsArr.length - 1) >= 0
          ? this.webreportcanbeuploaded - (this.webReportDetailsArr.length - 1)
          : 0;
      if (this.webreportcountcanbeuploaded >= 0) {
        this.webReportDetailsArr.splice(i, 1);
      }
      var duplicatecount = 0;
      this.webReportDetailsArr.forEach((y) => {
        if (y.duplicateEntry == true) {
          duplicatecount += 1;
        }
      });
      if (duplicatecount == 1) {
        this.webReportDetailsArr.forEach((y) => {
          if (y.duplicateEntry == true) {
            y.duplicateEntry = false;
          }
        });
      }
    },
    validateField(weburlObj, index) {
      if (weburlObj) {
        if (
          weburlObj.reportWebsiteUrl &&
          weburlObj.reportWebsiteUrl.length > 0
        ) {
          weburlObj.validWebsiteUrl = this.isValidURL(
            weburlObj.reportWebsiteUrl
          );
        }
        if (weburlObj.validWebsiteUrl) {
          for (var i = 0; i < this.webReportDetailsArr.length; i++) {
            if (i != index) {
              if (
                this.webReportDetailsArr[i].reportWebsiteUrl ==
                weburlObj.reportWebsiteUrl
              ) {
                weburlObj.duplicateEntry = true;
                this.webReportDetailsArr[i].duplicateEntry = true;
                this.duplicateUrlArrIndexes.push(i);
                break;
              } else {
                weburlObj.duplicateEntry = false;
                this.webReportDetailsArr[i].duplicateEntry = false;
              }
            } else {
              weburlObj.duplicateEntry = false;
              this.webReportDetailsArr[i].duplicateEntry = false;
            }
          }
        }
      }
    },
    countChar($event) {
      this.totaltypedchar = this.report_notes.length;
      if (this.totaltypedchar <= this.totalcharallowedfornote) {
        console.log(this.report_notes, this.totaltypedchar);
      } else {
        this.report_notes = this.report_notes.substring(
          0,
          this.totalcharallowedfornote
        );
        this.totaltypedchar = this.report_notes.length;
      }
    },
    resetOtherFields() {
      if (this.selected_reportSubmitMethod === "_desktop") {
        this.webReportDetailsArr = [
          {
            reportWebsiteUrl: "",
            reportWebsiteUname: "",
            reportWebsitePass: "",
            validWebsiteUrl: true,
            selectedDiagCenter: "",
            diagnostic_center_name: "",
            showAddDiagBtn: false,
            show_add_diatgnosticCenter: false,
            duplicateEntry: false,
            webReportId: "",
          },
        ];
        this.webreportcountcanbeuploaded =
          parseInt(this.webreportcanbeuploaded, 10) -
          this.webReportDetailsArr.length;
        this.report_notes = "";
      } else {
        if (document.getElementById("uploadFile1")) {
          document.getElementById("uploadFile1").value = "";
        }
        this.datatransferobj = new DataTransfer();
        this.selectedFiles = [];
        this.files = [];
        this.tempFileList = [];
        this.validFileExt = true;
        this.validFileSize = true;
        this.validFileCount = true;
        this.filecountcanbeuploaded = parseInt(this.filescanbeuploaded, 10);
        this.report_notes = "";
      }
    },
  },
  computed: {
    ...mapGetters([
      "gett_allstatus",
      "gett_downloadfileUrl",
      "gett_uploadedfile",
      "gett_report_url",
      "gett_patient_reports",
      "gett_deletedPatient_reports",
      "gett_updatedPatient_reports",
      "gett_allowedFileSize",
    ]),
    showClosePopUp() {
      var self = this;
      self.show_modal = self.showmodal;
      self.browseBtnTxt = "Select files";
      if (!self.show_modal) {
        self.toBeUploadObjLoaded = false;
        document.body.classList.remove("modal-open");
        self.getDiagnosticCenterList();
        self.resetPopUp();
      } else {
        document.body.classList.add("modal-open");
      }
    },
    showCloseEditPopUp() {
      var self = this;
      self.updateModal = self.updatemodal;
      if (self.updateModal && !self.editObjLoaded) {
        self.selectedDiagCenter = self.diagnosticcentername;
        self.selected_reportSubmitMethod = "_web";
        self.report_notes = self.uploadednotes;
        self.reportWebsiteUrl = self.reportweburl;
        self.reportWebsiteUname = self.reportweburluname;
        self.reportWebsitePass = self.reportweburlpass;
        self.tenantId = self.tenantid;

        self.webReportDetailsArr = [];
        var temp = {
          reportWebsiteUrl: self.reportWebsiteUrl,
          reportWebsiteUname: self.reportWebsiteUname,
          reportWebsitePass: self.reportWebsitePass,
          selectedDiagCenter: self.selectedDiagCenter,
          diagnostic_center_name: "",
          validWebsiteUrl: true,
          showAddDiagBtn: false,
          show_add_diatgnosticCenter: false,
          duplicateEntry: false,
          webReportId: self.webreportid,
        };
        self.finalDiagnosticList.forEach((x) => {
          if (x.unique_id === self.selectedDiagCenter) {
            temp.diagnostic_center_name = x.name;
          }
        });
        self.webReportDetailsArr.push(temp);
        console.log(
          "TESTREPOTPOPUP>>>>showCloseEditPopUp()>>>>",
          self.selected_reportSubmitMethod,
          self.report_notes,
          self.reportWebsiteUrl,
          self.reportWebsiteUname,
          self.reportWebsitePass,
          self.webReportDetailsArr
        );
        self.editObjLoaded = true;
      }
      if (!self.updateModal) {
        self.resetPopUp();
      }
    },
    getInvestigationId() {
      var self = this;
      //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>1");
      if (
        self.show_modal &&
        "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27" &&
        !self.toBeUploadObjLoaded
      ) {
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>2");
        self.encounter_id = self.encounterid;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>3");
        self.reportType = "All";
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>4");
        self.testType = "X-Ray Barium Follow Through";
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>5");
        self.diagnostic_center_name = self.diagnosticcentername;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>6");
        self.tenantId = self.tenantid;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>7");
        self.$store.state.helper.max_report_file_count = parseInt(
          self.maxreportfilecount,
          10
        );
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>8");
        self.$store.state.helper.max_web_report_count = parseInt(
          self.maxwebreportcount,
          10
        );
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>9");

        //HANDLE THE CALCULATION here****
        self.webreportcountcanbeuploaded =
          parseInt(self.webreportcanbeuploaded, 10) -
          this.webReportDetailsArr.length;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>10");
        self.filecountcanbeuploaded = parseInt(self.filescanbeuploaded, 10);
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>11");

        if (self.selectedTestType) {
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>16");
          self.selected_test_type.test_name = "X-Ray Barium Follow Through";
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>17");
          self.selected_test_type.selected = true;
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>18");
        }
        self.toBeUploadObjLoaded = true;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>19>>","27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",self.reportType,self.testType);
        //alert(self.encounter_id);
      }
    },
    getDownloadUrl() {
      if (
        this.gett_downloadfileUrl &&
        this.gett_downloadfileUrl.length > 0 &&
        this.gett_downloadfileUrl.indexOf(
          "documents-gen-ehr-dev.s3.amazonaws.com"
        )
      ) {
        if (this.viewItem & !this.downLoadItem) {
          this.fileUrl = this.gett_downloadfileUrl;
          //console.log("View URL-->", this.gett_downloadfileUrl);
          window.open(this.fileUrl, "_blank", "channelmode=1");
          this.viewItem = false;
          this.downLoadItem = false;
        }
        if (!this.viewItem & this.downLoadItem) {
          this.fileUrl = this.gett_downloadfileUrl;
          //console.log("Download URL-->" + this.gett_downloadfileUrl);
          // var ifrm = document.createElement("iframe");
          // ifrm.setAttribute("src", this.fileUrl);
          // ifrm.style.width = "100px";
          // ifrm.style.height = "100px";
          // ifrm.style.display="none";
          // document.body.appendChild(ifrm).click();
          // var anchor = document.createElement('a');
          // anchor.setAttribute("download", true);
          // anchor.setAttribute("href", this.fileUrl);
          // anchor.click();
          // let blob = new Blob([this.fileUrl], { type: 'image/jpeg' });
          // let link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = true;
          // link.click();
        }
      }
    },
    //After getting the File Upload key, then Save the data into the database
    getUploadedFileNames() {
      var self = this;
      if (
        self.gett_uploadedfile &&
        self.gett_uploadedfile.indexOf(self.stringToBeCropped) !== -1 &&
        self.uploadFlag === true
      ) {
        var tem = self.gett_uploadedfile;
        if (tem) {
          if (self.selected_reportSubmitMethod === "_desktop") {
            //first upload the file
            //console.log("In getUploadedFileNames--------->>>");
            self.CustomerTestReportsModel = {
              customer_Id: self.modifiedById,
              encounter_Id: " ", //this needs to be a space or any string value
              report_type: self.reportType,
              test_type: self.testType,
              created_date: new Date().toISOString(),
              modified_date: new Date().toISOString(),
              created_userid: self.modifiedById,
              report_actual_name: self.tempFiles,
              report_user_friendly_name: self.tempFiles,
              report_file_key: self.stringToBeCropped + self.tempFiles,
              report_notes: self.report_notes ? self.report_notes : "",
              tenant_id: self.tenantId,
            };
            //setTimeout(() => {
            //console.log(self.CustomerTestReportsModel);
            //s3api.ac_patient_web_reports_save(self.CustomerTestReportsModel,self.tenantId);
            //},0);
            self.uploadFlag = false;
            //self.CustomerViewModel.unshift(self.CustomerTestReportsModel);
          }
          //If Save & continue don't close the popup, instead reset it.
          if (this.saveType === "save-reset") {
            this.resetPopUp();
          }
        }
      }
    },
    //Get All reports
    getReportDetails() {
      if (
        this.gett_patient_reports &&
        (this.gett_patient_reports.hasOwnProperty("unique_id") ||
          this.gett_patient_reports.length > 0) &&
        !this.deleteFlag
      ) {
        ////console.log("<<<<<<<<<<<>>>>>>>>>>>>>");
        ////console.log(this.gett_patient_reports);
        if (Array.isArray(this.gett_patient_reports) === true) {
          this.CustomerViewModel = this.gett_patient_reports;
        } else if (Array.isArray(this.gett_patient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_patient_reports);
        }
        //alert(this.saveType);
        if (this.saveType !== "save-reset") {
          this.closePopUp("fileReport");
        } else {
          this.resetPopUp();
        }
        //else{
        //var temp = this.selected_reportSubmitMethod;
        //this.resetPopUp();
        //this.selected_reportSubmitMethod = temp;
        //}
      }
    },
    getUpdatedStatus() {
      if (this.gett_updatedPatient_reports && this.updateFlag == true) {
        if (Array.isArray(this.gett_updatedPatient_reports) === true) {
          this.CustomerViewModel = this.gett_updatedPatient_reports;
        } else if (Array.isArray(this.gett_updatedPatient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_updatedPatient_reports);
        }
        this.$store.state.helper.showUpdatedAlertPopUp = true;
        this.updateFlag = false;
        if (this.updateType !== "update-reset") {
          this.closePopUp("editReport");
          this.resetPopUp();
        } else {
          var temp = this.selected_reportSubmitMethod;
          this.resetPopUp();
          this.selected_reportSubmitMethod = temp;
        }
      }
    },
    getDeletedStatus() {
      if (this.gett_deletedPatient_reports && this.deleteFlag) {
        if (
          Array.isArray(this.gett_deletedPatient_reports) === true &&
          this.gett_deletedPatient_reports.length > 0
        ) {
          this.CustomerViewModel = this.gett_deletedPatient_reports;
        }
        if (
          Array.isArray(this.gett_deletedPatient_reports) === true &&
          this.gett_deletedPatient_reports.length == 0
        ) {
          this.CustomerViewModel = [];
        } else if (Array.isArray(this.gett_deletedPatient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_deletedPatient_reports);
        }
      }
    },
  },
  watch: {
    selectedimageCategory(value) {
      if (!value) { this.allimages = []; return; }
      this.allimages = value.category === "All"
        ? this.imagespath
        : this.imagespath.filter(e => e.category === value.category);
    },
    featuresNoted: function (val, oldVal) {
      this.maxCountsign = (val ? val.length : 0);
    },

    inference: function (val, oldVal) {
      this.maxCountinfer = (val ? val.length : 0);
    },
    imgUrl(value) {
      var selected_value = value;
      if (selected_value != null) {
        this.showbtninsert = true;
      }
      else {
        this.showbtninsert = false;
      }
    },

    show_modal(val) {
      if (val && this.uploadfrom === "genamet") this.setall();
    },
    uploadfrom(val) {
      if (val === "genamet" && this.show_modal) this.setall();
    },
    fileNamesSuccessfullyUploadedArr: function (val, oldVal) {
      if (val.length > 0) {
        //console.log("fileNamesSuccessfullyUploadedArr>>>val ", val);
        //console.log("fileNamesSuccessfullyUploadedArr>>>OldVal ", oldVal);
      }
    },
  },
  updated() {
    // $(document).on("click", ".thumbnail", function (e) {
    //   debugger;
    //   const imgUrl = $(this).children("img").prop("src");
    //   this.imgUrl = imgUrl;
    // $("#editor").show();
    // $("#tick").show();
    // $("#btnSubmit").show();
    // $("#imgPreview").attr("src", imgUrl);
    // });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip({ container: "body" });
      $("body")
        .tooltip({ selector: '[data-toggle="tooltip"]' })
        .click(function () {
          $('[data-toggle="tooltip"]').tooltip("hide");
        });
    });
  },
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease-in-out;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: opacity 0.5s ease-in-out;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* Upload report css 9-4-19*/
.modal-dialog.wider-upload {
  max-width: 700px !important;
  width: 700px;
  background: #ffffff;
  border-radius: 3px;
  height: auto;
}

.modal-dialog.wider-upload .modal-body {
  padding: 10px 100px 30px 100px;
}

/*INPUT*/
.container-comm input {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

.container-comm input:focus {
  box-shadow: none;
  outline: none;
  border-color: #0056e0 !important;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.container-comm input:focus~label {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #0056e0 !important;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}

.container-comm input:valid~label {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #0056e0;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}

.container-comm input:valid~label {
  color: #606060;
}

.container-comm.grey.disable label.disable {
  top: -10px;
  font-size: 12px;
  left: 10px;
}

.container-comm.grey.disable input:disabled {
  color: #b9b9b9 !important;
}

.container-comm label {
  position: absolute;
  top: 10px;
  left: 20px;
  pointer-events: none;
  color: #606060;
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.container-comm .height-dft span.modal-mobile {
  display: none;
}

.container-comm input:focus~.height-dft span.modal-mobile,
.container-comm input:valid~.height-dft span.modal-mobile {
  display: block !important;
  font-size: 12px;
  color: #0056e0;
  font-weight: 500;
  margin-top: 0px;
  margin-left: -52px;
}

.container-comm.grey input,
.container-comm.grey label {
  background: #f8f9fb !important;
}

/*ERROR*/
.error-msg-hold input {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #f3453a !important;
  padding-left: 15px;
  font-size: 14px !important;
  font-weight: 500 !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

.error-msg-hold input:focus,
.error-msg-hold input:valid {
  box-shadow: none;
  outline: none;
  border-color: #f3453a;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.error-msg-hold input:focus~label,
.error-msg-hold input:valid~label {
  top: -10px;
  font-size: 12px;
  color: rgba(243, 69, 58, 1) !important;
  font-weight: 400;
  background: #fff;
  left: 10px;
  padding: 0 5px;
}

.error-msg-hold label {
  position: absolute;
  top: 10px;
  left: 20px;
  pointer-events: none;
  color: rgba(243, 69, 58, 0.8);
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.error-msg-hold .error {
  display: block;
  font-size: 12px;
  color: rgba(243, 69, 58, 0.8);
  font-weight: 500;
}

.error-msg-hold input:focus~span.error,
.error-msg-hold input:valid~span.error {
  display: block !important;
  font-size: 12px;
  color: rgba(243, 69, 58, 0.8);
  font-weight: 500;
  margin-top: 4px;
}

/* .error-msg-hold input:focus,
.error-msg-hold input:valid {
  border-color: rgba(243, 69, 58, 1) !important;
} */
span.error {
  display: none;
}

.error-msg-hold span.error {
  color: rgba(243, 69, 58, 0.8);
  display: block !important;
}

/*TEXTAREA*/
.container-TXT {
  position: relative;
}

.container-TXT textarea {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 80px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  margin-bottom: 20px;
}

.container-TXT textarea:focus {
  box-shadow: none;
  outline: none;
  border-color: #0056e0 !important;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  padding-top: 10px;
}

.container-TXT textarea:valid {
  box-shadow: none;
  outline: none;
  border-color: #eaebed;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  padding-top: 10px;
}

.container-TXT textarea:valid {
  color: #606060;
}

.container-TXT textarea:focus~label {
  top: -10px;
  font-size: 12px !important;
  color: #0056e0 !important;
  font-weight: 400;
  background: #fff;
  width: auto;
  padding: 0 5px;
  left: 10px;
}

.container-TXT textarea:valid~label {
  top: -10px;
  font-size: 12px !important;
  color: #0056e0;
  font-weight: 400;
  background: #fff;
  width: auto;
  padding: 0 5px;
  left: 10px;
}

.container-TXT textarea:valid~label {
  color: #606060;
}

.container-TXT label {
  position: absolute;
  top: 12px;
  left: 20px;
  pointer-events: none;
  color: #606060;
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "Poppins", sans-serif !important;
}

.text-2000 {
  position: absolute;
  right: 0;
  top: -17px;
  color: #0056e0;
  font-size: 13px;
  font-weight: 500;
}

/*SELECT*/
.mart-spacer {
  margin-top: 58px !important;
}

.mart-spacermr {
  margin-top: 70px !important;
}

.wrap-hold {
  position: relative !important;
  margin-top: 7px;
}

.col-md-12.wrap-hold {
  padding: 0;
  margin: 0;
}

.wrap {
  position: absolute;
  right: 0;
  top: 0px;
  width: 100%;
  left: 0;
  margin: 0 0 0 0px;
  height: 45px;
  padding: 0 15px !important;
}

.wrap select {
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  height: 40px !important;
}

.select {
  font-family: "Poppins", sans-serif !important;
  position: relative;
  width: 100%;
}

.select-text {
  position: relative;
  font-family: inherit;
  background-color: transparent;
  width: 100%;
  padding: 10px 34px 10px 12px;
  font-size: 14px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  font-weight: 400 !important;
}

/* Remove focus */
.select-text:focus {
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0) !important;
}

/* Use custom arrow */
.select .select-text {
  appearance: none;
  -webkit-appearance: none;
  color: #111 !important;
}

.select-text.show-first option:first-child {
  display: block;
}

.select:after {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  padding: 4px;
  content: "";
  pointer-events: none;
  background: #ffffff url(../../static/images/arrow-down.png) 0px 0px no-repeat;
}

.select-text:focus {
  border: solid 1px #0056e0 !important;
}

.select-label {
  color: #606060 !important;
  font-size: 14px;
  font-weight: 400 !important;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 10px;
  transition: 0.2s ease all;
}

.select-text:focus~.select-label {
  color: #0056e0 !important;
  top: -10px;
  transition: 0.2s ease all;
  background: #ffffff;
  font-size: 12px;
  width: auto;
  padding: 0 5px;
  left: 10px;
}

.select-text:valid~.select-label {
  color: #0056e0 !important;
  top: -10px;
  transition: 0.2s ease all;
  background: #ffffff;
  font-size: 12px;
  width: auto;
  padding: 0 5px;
  left: 10px;
}

.select-text:valid~.select-label {
  color: #606060 !important;
}

.select-text:focus~.select-label {
  color: #0056e0 !important;
}

.select-text:focus~.select-bar:before,
.select-text:focus~.select-bar:after {
  width: 50%;
}

.select-highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 33.33% !important;
  float: left;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container .radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border-radius: 50%;
  border: solid 3px #c6c6c6;
}

.radio-container:hover input~.radio-checkmark {
  background-color: #ffffff;
}

.radio-container input:checked~.radio-checkmark {
  background-color: #c6c6c6;
}

.radio-container .radio-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.radio-container input:checked~.radio-checkmark:after {
  display: block;
}

.radio-container .radio-checkmark:after {
  top: 0px;
  left: 0px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #0056e1;
}

.modal-dialog.wider-upload .modal-header {
  border-bottom: none;
  padding: 0;
  margin: 0;
}

.modal-dialog.wider-upload .modal-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 17px;
}

.modal-dialog.wider-upload .close.up-close {
  color: #8a8a8a !important;
  font-size: 28px;
  font-weight: 300;
  opacity: 1 !important;
  outline: none;
  position: relative;
  right: 12px;
  top: 8px;
}

.modal-dialog.wider-upload .close.up-close:active,
.modal-dialog.wider-upload .close.up-close:focus {
  color: #111 !important;
}

.row.choose-select-hold {
  width: 100%;
  /* display: none; */
  padding: 0;
  margin: 10px 0;
}

.web-repo-hold {
  width: 100%;
  /* display: none; */
  padding: 0;
  margin: 10px 0;
}

.add-category-section {
  position: relative;
}

.add-category-btn {
  position: absolute;
  bottom: -20px;
  right: 0px;
  width: 26px !important;
  height: 20px !important;
  padding: 0px !important;
  min-width: 26px;
}

a.add-category-btn span:first-of-type {
  top: 25%;
  bottom: 25%;
  width: 10%;
  left: 45%;
}

a.add-category-btn span:last-of-type {
  left: 25%;
  right: 25%;
  height: 10%;
  top: 45%;
}

a.add-category-btn span {
  position: absolute;
  transition: 0.3s;
  background: white;
  border-radius: 2px;
}

a.add-category-btn.open span:last-of-type {
  left: 50%;
  right: 50%;
}

a.add-category-btn.open span:last-of-type {
  transform: rotate(90deg);
}

a.add-category-btn.open span:first-of-type,
a.add-category-btn.open span:last-of-type {
  transform: rotate(90deg);
}

.add-category-part.mart-25.inline-add.clearfix {
  position: relative;
  width: 100%;
  padding: 0 15px;
  top: 60px;
  margin-bottom: 50px;
  display: block;
}

.web-repo-hold {
  width: 100%;
  padding: 0 15px;
  margin: 0 0;
}

.row.wd-100 {
  width: 100%;
  margin-top: 20px;
}

.tags-hold ul {
  padding: 0;
  margin: 0;
}

.tags-hold ul li {
  float: left;
  list-style: none;
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 5px 30px 5px 10px;
  background: #0056e0;
  border-radius: 50px;
  position: relative;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  cursor: default;
  width: auto;
  margin-top: 1px;
  color: #fff;
}

.tags-hold ul li a {
  position: absolute;
  top: 2px;
  right: 10px;
  color: #fff;
  font-size: 20px;
}

.tags-hold ul li a i {
  font-size: 20px;
  color: #c2c4c5;
}

/* .select-file-holder input[type='file'] {color: transparent;} */
.select-file-holder {
  width: 98px;
  float: left;
}

.pdr-r10 {
  margin-right: 10px;
}

.row.wd-100 .col-md-12 {
  padding-right: 0px;
}

.custom-file-input {
  opacity: 1 !important;
  outline: none !important;
}

.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}

.custom-file-input::file-upload-button {
  visibility: hidden;
}

.custom-file-input::before {
  content: "Choose file";
  display: inline-block;
  background: #ffffff;
  border: 1px solid #d7d7d7;
  border-radius: 0px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 500;
  font-size: 13px;
}

.custom-file-input:hover::before {
  background: #f9f9f9;
}

.custom-file-input:active::before {
  background: #ffffff;
}

.upload-outer p {
  font-weight: 500;
}

.file-upload.btn.btn-default {
  border: 1px solid #0056e0 !important;
  border-radius: 0px !important;
  float: none;
  margin: 10px 0 0 0 !important;
  padding: 8px 16px;
  background: #0056e0;
}

.info-upload {
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border: 0px solid rgba(0, 86, 225, 0.5);
  padding: 5px 5px 5px 32px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;
  font-weight: 400;
  position: relative;
}

.file-upload {
  position: relative;
  overflow: hidden;
  margin: 10px;
}

.file-upload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}

.file-upload.btn.btn-default span {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

/*SPAN*/
.container-comm span {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  padding: 10px 15px;
}

.container-comm .valid {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #606060;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}

.add-notes-hold #add_category {
  margin: 0 0;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
}

.add-new-btn,
.investi-clear-btn {
  float: right;
  padding: 15px;
  position: relative;
  padding-right: 40px;
  width: 100%;
  text-align: right;
  font-weight: 500;
}

.add-new-btn {
  margin-right: 7px;
}

.add-notes-hold .material-icons {
  float: left;
  margin: 0 0;
  top: -1px;
  right: 8px;
  padding: 0 0;
}

.add-new-btn i {
  color: #66696f;
  position: absolute;
  top: 13px;
  right: 15px;
}

#add_investigation .material-icons.open,
#add_category .material-icons.open {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.error-upl {
  position: absolute;
  bottom: -20px;
  left: 20px;
  font-size: 12px;
  font-weight: 500;
}

.filename {
  float: left;
  width: calc(100% - 35px);
  padding-top: 10px;
}

.timehold {
  font-size: 11px;
  padding: 0 8px;
  float: left;
  width: 100%;
}

.add-new-btn.add-updatedbtn {
  padding: 0px;
  padding-right: 30px;
  margin-right: 0px;
}

.add-new-btn.add-updatedbtn i {
  top: 0px;
  right: 0px;
}

.primary-btn.add-category-btn span {
  padding: 0px 5px;
}

.info-upload:before {
  width: 32px;
  height: 24px;
  position: absolute;
  display: block;
  content: "";
  left: 0;
  background: url(../../static/images/dashboard-newicons.png) no-repeat;
  background-position: 0px -897px;
}

.container-comm .add-category-btn.add-dcn span {
  height: initial !important;
  background: transparent !important;
  border: none !important;
  color: #fff !important;
}

.parenthold {
  position: relative;
}

.add-user-btn {
  background: #0056e0;
  color: #fff;
  font-size: 20px;
  position: relative;
  top: -14px;
  float: right;
  outline: 0;
}

.add-user-btn,
.remove-btn {
  border: 1px solid #0056e0;
  padding: 1px 6px 0 6px;
  line-height: 20px;
  height: 24px;
  width: 24px;
  right: 0;
}

.remove-btn {
  background: transparent;
  color: #0056e0;
  font-size: 16px;
  position: absolute;
  bottom: -10px;
  font-weight: 500;
}

#weburlsection:last-of-type .remove-btn {
  right: 24px;
}

.primary-btn.add-category-btn.add-dcn.h24-btn {
  height: 24px !important;
  width: 24px !important;
  bottom: -23px;
  min-width: 24px;
}

.primary-btn.add-category-btn.add-dcn.h24-btn span {
  font-size: 18px !important;
}

.add-new-btn.addnote-inline {
  padding: 0;
}

.add-new-btn.addnote-inline i.material-icons {
  top: -1px;
  right: -28px;
}

.modal-mask.upl-hold .modal-header {
  border-bottom: 0px solid transparent;
}

.modal-mask:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-wrapper {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  width: 100%;
}

.info-upload-mail {
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border: 0px solid rgba(0, 86, 225, 0.5);
  padding: 5px 5px 5px 28px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;
  font-weight: 400;
  position: relative;
}

.info-upload-mail:before {
  width: 24px;
  height: 24px;
  position: absolute;
  display: block;
  content: "";
  left: 0;
  background: url(../../static/images/dashboard-newicons.png) no-repeat;
  background-position: -57px -899px;
}

.alert-maxfiles {
  background-color: #fff;
  border-radius: 4px;
  border: 0px solid #f5c6cb;
  width: 100%;
  padding: 0 8px;
  margin: 10px 0 0px 0;
  float: left;
  margin-left: -35px;
}

.alert-red1alert-maxfiles p {
  color: rgba(243, 69, 58, 0.8);
}

.alert-maxfiles p::before {
  width: 24px;
  height: 24px;
  position: relative;
  display: block;
  content: "";
  left: 0px;
  float: left;
  background: url(../../static/images/dashboard-newicons.png) no-repeat;
  background-position: -117px -1051px;
}

.info-upload-i {
  position: relative;
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border: 0px solid rgba(0, 86, 225, 0.5);
  padding: 5px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;
  padding-left: 30px;
  font-weight: 400;
}

.info-upload-i:before {
  width: 28px;
  height: 28px;
  position: absolute;
  display: block;
  content: "";
  left: 0;
  background: url(../../static/images/material_co_icon-new.png) no-repeat;
  background-position: -122px -846px;
  top: 4px;
}

.alert-red1 {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
  width: 100%;
  padding: 8px;
  margin: 0 0 15px 0;
  float: left;
}

.alert-red1 p {
  color: rgba(243, 69, 58, 0.8);
  text-align: center;
}

.alert-red1 p::before {
  width: 24px;
  height: 24px;
  position: relative;
  display: block;
  content: "";
  left: 26px;
  float: left;
  background: url(../../static/images/dashboard-newicons.png) no-repeat;
  background-position: -56px -900px;
  top: 1px;
}

.clinicalnote.modal-container.wider-midB {
  width: 600px;
}

.alert-red1.L-inline p::before {
  left: 42px;
  top: 1px;
}

.error-info {
  color: rgba(243, 69, 58, 0.8) !important;
}

.clinicalnote.modal-container.wider-midB .close.up-close {
  position: absolute;
  right: 20px;
  top: 12px;
}

.clinicalnote.modal-container.wider-midB .black-text {
  color: #000;
  padding: 0 0 0 15px;
  display: inline-block;
}

.col-md-12.text-center.file-detail-hold {
  border: 1px solid #ececec;
  background: #f4f4f4;
  padding: 20px 15px;
  margin-bottom: 15px;
  float: left;
  max-height: 144px;
  overflow-y: auto;
}

.col-md-12.text-center.file-detail-hold .Upload report {
  min-height: 30px;
}

.tags-hold .list:empty {
  background: url(../../static/images/imgpsh_fullsize_anim.png) no-repeat;
  min-height: 40px;
  background-position: center;
}

.file-upload.btn.btn-default:hover {
  background: #0043a4;
  color: #ffffff;
  text-decoration: none;
  border-color: #0043a4;
  outline: none;
}



.marker-container {
  position: relative;
  z-index: 1000;
  /* Adjust the z-index as needed */
}

.clinicalnote.modal-container.wider-midB {
  width: 100%;
  max-width: 850px;
  border-radius: 10px;
}

.upload-outer .thumbnail {
  margin-bottom: 40px;
}

.upload-outer .thumbnail img {
  max-width: 100%;
  height: 200px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.upload-outer .thumbnail .caption h3 {
  font-size: 18px !important;
  margin: 10px 0 0;
}

ul.annotation-cat {
  display: flex;
  width: 100%;
  margin: 20px 0;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-bottom: 10px;
}

ul.annotation-cat li {
  margin-right: 10px;
}

ul.annotation-cat li a {
  background: #e5ebeb;
  border-radius: 30px;
  display: flex;
  padding: 5px 10px;
  border: 1px solid #ddd;
  min-width: 110px;
  justify-content: center;
  align-items: center;
  color: #000;
}

ul.annotation-cat li a:hover,
ul.annotation-cat li a.active {
  background: #0056e1;
  color: #fff;
  border-color: #0056e1;
}

.annotation-modal button.close.up-close {
  top: -15px !important;
  right: -15px !important;
  margin: 0;
  padding: 0;
  z-index: 9;
}

.annotation-modal h5.modal-title {
  font-size: 20px !important;
  font-weight: 500;
  margin: 0 0 15px !important;
}

.annotation-gallery {
  overflow: auto;
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 15px;
}

.annotation-gallery .row {
  margin-right: -7.5px;
  margin-left: -7.5px;
}

.annotation-gallery .row .col-md-4 {
  padding-left: 7.5px;
  padding-right: 7.5px;
}

.annotation-gallery h4 {
  margin: 0;
}

.annotation-gallery .annotation-image {
  margin-top: 15px;
}

.annotation-gallery .annotation-image img {
  width: 100%;
  border-radius: 10px;
  height: 160px;
  object-fit: cover;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}

.modal-bottom button {
  margin-left: 10px;
  padding: 6px 20px;
}

.modal-bottom button.btn.btn-secondary {
  background: none;
  color: #007bff;
  border-color: #007bff;
}

.holder img#imgPreview {
  max-width: 100%;
  margin: 20px auto;
  display: block;
}

textarea.form-control {
  border-color: #a5a5a5;
}

#sidebarMenu .nav-item a {
  background: #f2f6f7;
  border: 1px solid #e3e5e8;
  border-radius: 5px;
  color: #000;
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-weight: 500;
}

#sidebarMenu .nav-item a:hover,
#sidebarMenu .nav-item a.active {
  color: #007bff;
}

#sidebarMenu+.col-md-12 input#btnSubmit {
  color: #fff !important;
}

#sidebarMenu .nav-item a img {
  margin-right: 5px;
}

#sidebarMenu .nav.flex-column {
  display: flex;
  flex-wrap: inherit;
  flex-direction: row !important;
}

.annotation-modal .upload-outer input#fileUpload {
  margin-bottom: 0;
}

.annotation-modal .text-2000 {
  right: 15px;
  top: 0;
}

.is-invalid {
  border: 1px solid red !important;
}

.genamet-platform {
  padding: 0 0px 20px;
}

.genamet-platform .ehr-popup-header-colored {
  display: flex !important;
}

.model-body-popup {
  padding: 0 30px;
}

.ehr-popup-header-colored {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  flex-shrink: 0;
}

.ehr-popup-header-colored .ehr-popup-title {
  color: #fff;
  font-size: 15px;
}

.ehr-popup-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
}

.ehr-popup-header-colored .ehr-popup-title svg {
  color: rgba(255, 255, 255, 0.8);
}

.ehr-popup-header-colored .ehr-popup-close {
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  line-height: 1;
}

.popup-header-blue {
  background: linear-gradient(135deg, #0056D2 0%, #1273EB 100%);
}

.pup-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.pup-field {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 13px 14px;
  display: flex;
  flex-direction: column;
}

.pup-field-label {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 9px;
  font-family: 'Poppins', sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  color: #0F172A;
}

.pup-field-label svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: #1273EB;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pup-field textarea {
  width: 100%;
  min-height: 96px;
  resize: vertical;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #FBFDFF;
  padding: 10px 12px;
  font-size: 12.5px;
  line-height: 1.6;
  font-family: 'Inter', sans-serif;
  color: #1E293B;
  outline: none;
  transition: all 0.15s;
}

.pup-chiprow {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.pup-chip {
  background: #fff;
  color: #64748B;
  border: 1px dashed #CBD5E1;
  border-radius: 99px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: all 0.15s;
}

.text-2000 {
  position: absolute;
  right: 445px !important;
  top: 508px !important;
  color: #0056e0;
  font-size: 13px;
  font-weight: 500;
}

.pup-field-label label {
  margin-bottom: 0;
}

.pup-field-label textarea.form-control {
  margin-bottom: 0;
}

.text-2000-sec {
  color: #0056e0;
  font-size: 13px;
  font-weight: 500;
}

.av-btn-ghost {
  background: #fff;
  color: #64748B;
  border: 1px solid #E2E8F0;
  border-radius: 7px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pup-chip:hover {
  background: #EFF6FF;
  color: #1273EB;
  border-color: #1273EB;
  border-style: solid;
}

.av-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #1273EB;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.av-btn-primary:hover {
  background: #0056D2;
}

.av-btn-primary svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: rgb(255, 255, 255);
  stroke-width: 3;
  stroke-linecap: round;
}

.av-btn-ghost:hover {
  background: #F1F5F9;
  color: #334155;
}

.popup-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.pup-drop {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1.5px dashed #CBD5E1;
  border-radius: 10px;
  background: #fff;
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.15s;
}

.pup-drop-ico {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFF6FF;
  border: 1px solid #DBEAFE;
  color: #1273EB;
}

.pup-drop-ico svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: rgb(18, 115, 235);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pup-drop-txt {
  flex: 1;
  min-width: 0;
}

.pup-drop-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #1E293B;
}

.pup-drop-hint {
  font-size: 11.5px;
  color: #94A3B8;
  margin-top: 2px;
}

.pup-drop-cta {
  flex-shrink: 0;
  background: #1273EB;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 8px 16px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}

.pup-drop:hover,
.pup-drop.dragging {
  border-color: #1273EB;
  background: #EFF6FF;
}

.popup-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #64748b;
  margin: 0 0 10px
}

.pup-drop.is-dragover {
  background: #e8f1ff;
  border-color: #1a73e8
}

.pup-field .form-control {
  resize: vertical;
  min-height: 96px
}

.pup-field .form-control::placeholder {
  color: #a5b0c0
}

.pup-foot {
  display: flex;
  align-items: center;
  gap: 12px;
  border-top: 1px solid #e5eaf2;
  padding: 14px 24px
}

.pup-foot-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
  font-size: 12px;
  color: #64748b
}

.pup-foot-note svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2
}

.pup-foot .av-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px
}

.pup-foot .av-btn-primary svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2
}

.pup-foot .av-btn-primary:disabled {
  opacity: .45;
  cursor: not-allowed
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
